import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type genAiClassificationTag = {
  __typename?: 'AIClassificationTag';
  explanation?: Maybe<Scalars['String']>;
  tag: Scalars['String'];
  weight: Scalars['Float'];
};

export enum AiProcessingStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  NotBegun = 'NOT_BEGUN',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

/** Affects the placement of the widget */
export enum ActivatorType {
  Card = 'CARD',
  Expperttab = 'EXPPERTTAB',
  Tab = 'TAB'
}

export enum AnchorPosition {
  After = 'AFTER',
  Before = 'BEFORE'
}

export type genAnswerInput = {
  answer: Scalars['String'];
  id: Scalars['String'];
};

/** Permissions which can be assigned to Remark staff users */
export enum AssignableGlobalPermission {
  EditBranding = 'EDIT_BRANDING',
  EditCannedResponses = 'EDIT_CANNED_RESPONSES',
  EditGlobalCannedResponses = 'EDIT_GLOBAL_CANNED_RESPONSES',
  EditIntegrations = 'EDIT_INTEGRATIONS',
  EditProducts = 'EDIT_PRODUCTS',
  EditVendors = 'EDIT_VENDORS',
  EditVendorExperts = 'EDIT_VENDOR_EXPERTS',
  EditVendorMembers = 'EDIT_VENDOR_MEMBERS',
  EditVendorTeams = 'EDIT_VENDOR_TEAMS',
  EditWidgetSettings = 'EDIT_WIDGET_SETTINGS',
  InvokeDevOpsApiOperations = 'INVOKE_DEV_OPS_API_OPERATIONS',
  UnattributeConversions = 'UNATTRIBUTE_CONVERSIONS',
  ViewConversations = 'VIEW_CONVERSATIONS',
  ViewNps = 'VIEW_NPS',
  ViewPii = 'VIEW_PII'
}

/** Permissions which can be assigned on a per-vendor basis */
export enum AssignableVendorPermission {
  EditBranding = 'EDIT_BRANDING',
  EditCannedResponses = 'EDIT_CANNED_RESPONSES',
  EditIntegrations = 'EDIT_INTEGRATIONS',
  EditProducts = 'EDIT_PRODUCTS',
  EditVendorExperts = 'EDIT_VENDOR_EXPERTS',
  EditVendorTeams = 'EDIT_VENDOR_TEAMS',
  EditWidgetSettings = 'EDIT_WIDGET_SETTINGS',
  ViewConversations = 'VIEW_CONVERSATIONS',
  ViewNps = 'VIEW_NPS',
  ViewPii = 'VIEW_PII'
}

export type genAttribution = {
  __typename?: 'Attribution';
  chatEventDateTime?: Maybe<Scalars['DateTime']>;
  chattingExpert?: Maybe<genExpertProfile>;
  conversation?: Maybe<genConversation>;
  /** The conversion id */
  id: Scalars['ID'];
  method?: Maybe<AttributionMethod | `${AttributionMethod}`>;
  vendorSegmentStats?: Maybe<genVendorSegmentStatistics>;
};

export enum AttributionMethod {
  Email = 'Email',
  Ip = 'Ip',
  Session = 'Session'
}

export type genAuction = {
  __typename?: 'Auction';
  availableExperts: Scalars['Float'];
  conversationId: Scalars['String'];
  conversationSid?: Maybe<Scalars['String']>;
  expiry: Scalars['DateTime'];
  id: Scalars['String'];
  vendor: genVendor;
  vendorId: Scalars['String'];
};

export type genAuctionEvent = {
  __typename?: 'AuctionEvent';
  auction: genAuction;
  type: AuctionEventType | `${AuctionEventType}`;
};

export enum AuctionEventType {
  ClaimedByOtherExpert = 'CLAIMED_BY_OTHER_EXPERT',
  Missed = 'MISSED',
  Offered = 'OFFERED'
}

export enum CannedContentType {
  CannedResponse = 'CANNED_RESPONSE',
  KnowledgeBase = 'KNOWLEDGE_BASE'
}

export type genCannedResponse = {
  __typename?: 'CannedResponse';
  body: Scalars['String'];
  /** The date the object was created. */
  created: Scalars['DateTime'];
  id: Scalars['ID'];
  images: Array<genCannedResponseImage>;
  tags: Array<Scalars['String']>;
  title: Scalars['String'];
  type: CannedContentType | `${CannedContentType}`;
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
};

export type genCannedResponseImage = {
  __typename?: 'CannedResponseImage';
  /** The date the object was created. */
  created: Scalars['DateTime'];
  id: Scalars['ID'];
  mediaURL: Scalars['String'];
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
};

export type genCart = {
  __typename?: 'Cart';
  /** The date the object was created. */
  created: Scalars['DateTime'];
  id: Scalars['ID'];
  items: Array<genCartItem>;
  totalPrice: Scalars['Float'];
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
};


export type genCartTotalPriceArgs = {
  currency?: InputMaybe<Scalars['String']>;
};

export type genCartItem = {
  __typename?: 'CartItem';
  cart?: Maybe<genCart>;
  /** The date the object was created. */
  created: Scalars['DateTime'];
  currency?: Maybe<Currency | `${Currency}`>;
  id: Scalars['ID'];
  price?: Maybe<Scalars['Float']>;
  product: genProduct;
  quantity: Scalars['Float'];
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
  variant?: Maybe<genVariant>;
};

export type genCategory = {
  __typename?: 'Category';
  allProducts: genPaginatedProduct;
  /** The date the object was created. */
  created: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  publishedProducts: genPaginatedProduct;
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
};

export type genCategoryEdge = {
  __typename?: 'CategoryEdge';
  cursor: Scalars['ID'];
  node: genCategory;
};

export type genChatEvent = {
  __typename?: 'ChatEvent';
  body?: Maybe<Scalars['String']>;
  chatServiceEventId?: Maybe<Scalars['String']>;
  chatServiceUsername?: Maybe<Scalars['String']>;
  conversationId: Scalars['String'];
  /** The date the object was created. */
  created: Scalars['DateTime'];
  eventId?: Maybe<Scalars['String']>;
  expert?: Maybe<genExpertProfile>;
  id: Scalars['ID'];
  identity?: Maybe<genIdentity>;
  media: Array<genChatEventMedia>;
  npsSurvey?: Maybe<genNetPromoterScoreSurvey>;
  recommendationId?: Maybe<Scalars['String']>;
  type: ChatEventType | `${ChatEventType}`;
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
};

export type genChatEventEdge = {
  __typename?: 'ChatEventEdge';
  cursor: Scalars['ID'];
  node: genChatEvent;
};

export type genChatEventMedia = {
  __typename?: 'ChatEventMedia';
  /** The date the object was created. */
  created: Scalars['DateTime'];
  id: Scalars['ID'];
  mediaURL: Scalars['String'];
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
};

export enum ChatEventType {
  ChangeConversationDeviceViaUrl = 'ChangeConversationDeviceViaURL',
  Closed = 'Closed',
  Escalated = 'Escalated',
  EscalationFailed = 'EscalationFailed',
  FindingExpert = 'FindingExpert',
  IdleCancel = 'IdleCancel',
  IdleWarningCustomerAbandon = 'IdleWarningCustomerAbandon',
  IdleWarningExpertAbandon = 'IdleWarningExpertAbandon',
  Joined = 'Joined',
  Left = 'Left',
  Message = 'Message',
  NpsRequest = 'NPSRequest',
  NameRequest = 'NameRequest',
  NoExpertsAvailable = 'NoExpertsAvailable',
  PiiAcknowledged = 'PiiAcknowledged',
  PiiRequest = 'PiiRequest',
  Recommended = 'Recommended',
  Reopened = 'Reopened',
  Started = 'Started',
  TransferFailed = 'TransferFailed',
  TransferForced = 'TransferForced',
  TransferRequested = 'TransferRequested'
}

export type genConversation = {
  __typename?: 'Conversation';
  cart?: Maybe<genCart>;
  conversions: Array<genConversion>;
  /** The date the object was created. */
  created: Scalars['DateTime'];
  currentExpert?: Maybe<genExpertProfile>;
  customerIdentity: genIdentity;
  events: genPaginatedChatEvent;
  id: Scalars['ID'];
  lastExpert?: Maybe<genExpertProfile>;
  lastMessageDate?: Maybe<Scalars['DateTime']>;
  mostRecentSegmentStats?: Maybe<genVendorSegmentStatistics>;
  npsSurveys: Array<genNetPromoterScoreSurvey>;
  participants: Array<genConversationParticipant>;
  recommendations: genPaginatedRecommendation;
  status?: Maybe<ConversationStatus | `${ConversationStatus}`>;
  twilioSid: Scalars['String'];
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
  vendor: genVendor;
};


export type genConversationConversionsArgs = {
  filter: genConversionFilterInput;
};


export type genConversationEventsArgs = {
  cursor?: InputMaybe<Scalars['ID']>;
  last: Scalars['Int'];
};


export type genConversationNpsSurveysArgs = {
  lead?: InputMaybe<Scalars['String']>;
};


export type genConversationParticipantsArgs = {
  includePastParticipants?: InputMaybe<Scalars['Boolean']>;
};


export type genConversationRecommendationsArgs = {
  cursor?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<genRecommendationSortInput>>;
};

export enum ConversationConversionStatus {
  Attributed = 'ATTRIBUTED',
  Converted = 'CONVERTED',
  None = 'NONE',
  Unattributed = 'UNATTRIBUTED'
}

export enum ConversationDeviceTransferType {
  Url = 'URL'
}

export type genConversationEdge = {
  __typename?: 'ConversationEdge';
  cursor: Scalars['ID'];
  node: genConversation;
};

export type genConversationFilterInput = {
  conversionStatus?: InputMaybe<ConversationConversionStatus | `${ConversationConversionStatus}`>;
  email?: InputMaybe<Scalars['String']>;
  expertId?: InputMaybe<Scalars['ID']>;
};

export type genConversationOfferEvent = {
  __typename?: 'ConversationOfferEvent';
  conversation: genOfferedConversation;
  type: ConversationOfferEventType | `${ConversationOfferEventType}`;
};

export enum ConversationOfferEventType {
  ClaimedByOtherExpert = 'CLAIMED_BY_OTHER_EXPERT',
  Offered = 'OFFERED'
}

export type genConversationOnExpertFilterInput = {
  status?: InputMaybe<Array<ConversationOnExpertStatus | `${ConversationOnExpertStatus}`>>;
  vendors?: InputMaybe<Array<Scalars['ID']>>;
};

export enum ConversationOnExpertStatus {
  Archived = 'ARCHIVED',
  Open = 'OPEN',
  Pending = 'PENDING'
}

export type genConversationParticipant = {
  __typename?: 'ConversationParticipant';
  avatarUrl?: Maybe<Scalars['String']>;
  chatServiceUsername: Scalars['String'];
  expertProfile?: Maybe<genExpertProfile>;
  name: Scalars['String'];
};

export enum ConversationSortField {
  LastMessageDate = 'lastMessageDate'
}

export type genConversationSortInput = {
  direction: SortOrder | `${SortOrder}`;
  field: ConversationSortField | `${ConversationSortField}`;
};

export enum ConversationStatus {
  Closed = 'Closed',
  Open = 'Open',
  Pending = 'Pending'
}

export type genConversion = {
  __typename?: 'Conversion';
  attributedChatEventDateTime?: Maybe<Scalars['DateTime']>;
  attributedChattingExpert?: Maybe<genExpertProfile>;
  /** The associated attribution, if there ever was one, no matter the current state of attribution on the Conversion */
  attribution?: Maybe<genAttribution>;
  attributionMethod?: Maybe<AttributionMethod | `${AttributionMethod}`>;
  conversation?: Maybe<genConversation>;
  /** The date the object was created. */
  created: Scalars['DateTime'];
  currency?: Maybe<Scalars['String']>;
  externalId: Scalars['String'];
  externalUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lead?: Maybe<Scalars['String']>;
  lineItems: Array<genConversionLineItem>;
  orderNumber?: Maybe<Scalars['String']>;
  platform: Scalars['String'];
  rawData: Scalars['String'];
  totalPrice?: Maybe<Scalars['Float']>;
  unattributedByUser?: Maybe<genUser>;
  unattributedDateTime?: Maybe<Scalars['DateTime']>;
  unattributedFromChat?: Maybe<Scalars['Boolean']>;
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
  vendor: genVendor;
};

export type genConversionEdge = {
  __typename?: 'ConversionEdge';
  cursor: Scalars['ID'];
  node: genConversion;
};

export type genConversionFilterInput = {
  conversionType: ConversionType | `${ConversionType}`;
};

export type genConversionLineItem = {
  __typename?: 'ConversionLineItem';
  /** The date the object was created. */
  created: Scalars['DateTime'];
  finalTotalPrice: Scalars['Float'];
  id: Scalars['ID'];
  lineTitle?: Maybe<Scalars['String']>;
  product?: Maybe<genProduct>;
  quantity: Scalars['Float'];
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
  variant?: Maybe<genVariant>;
};

export enum ConversionType {
  All = 'ALL',
  Attributed = 'ATTRIBUTED',
  ManuallyUnattributed = 'MANUALLY_UNATTRIBUTED',
  NotAttributed = 'NOT_ATTRIBUTED'
}

export enum CountryCode {
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  Ao = 'AO',
  Aq = 'AQ',
  Ar = 'AR',
  As = 'AS',
  At = 'AT',
  Au = 'AU',
  Aw = 'AW',
  Ax = 'AX',
  Az = 'AZ',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bl = 'BL',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Bq = 'BQ',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bv = 'BV',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  Cc = 'CC',
  Cd = 'CD',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  Co = 'CO',
  Cr = 'CR',
  Cu = 'CU',
  Cv = 'CV',
  Cw = 'CW',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Do = 'DO',
  Dz = 'DZ',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Es = 'ES',
  Et = 'ET',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fm = 'FM',
  Fo = 'FO',
  Fr = 'FR',
  Ga = 'GA',
  Gb = 'GB',
  Gd = 'GD',
  Ge = 'GE',
  Gf = 'GF',
  Gg = 'GG',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gs = 'GS',
  Gt = 'GT',
  Gu = 'GU',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hm = 'HM',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  Im = 'IM',
  In = 'IN',
  Io = 'IO',
  Iq = 'IQ',
  Ir = 'IR',
  Is = 'IS',
  It = 'IT',
  Je = 'JE',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Me = 'ME',
  Mf = 'MF',
  Mg = 'MG',
  Mh = 'MH',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Pm = 'PM',
  Pn = 'PN',
  Pr = 'PR',
  Ps = 'PS',
  Pt = 'PT',
  Pw = 'PW',
  Py = 'PY',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Sv = 'SV',
  Sx = 'SX',
  Sy = 'SY',
  Sz = 'SZ',
  Tc = 'TC',
  Td = 'TD',
  Tf = 'TF',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tl = 'TL',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Um = 'UM',
  Us = 'US',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vi = 'VI',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Ye = 'YE',
  Yt = 'YT',
  Za = 'ZA',
  Zm = 'ZM',
  Zw = 'ZW'
}

export type genCreateCartItem = {
  currency?: InputMaybe<Currency | `${Currency}`>;
  price?: InputMaybe<Scalars['Float']>;
  /** may be internal or external id */
  productId?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
  /** may be internal or external id */
  variantId?: InputMaybe<Scalars['ID']>;
};

export type genCreateCustomerEventInput = {
  cartItem?: InputMaybe<genCreateCartItem>;
  name?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  /** may be our internal or an external id */
  productId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sessionId: Scalars['ID'];
  type: CustomerEventInputType | `${CustomerEventInputType}`;
  vendorId: Scalars['String'];
};

export enum Currency {
  Aed = 'AED',
  Afn = 'AFN',
  All = 'ALL',
  Amd = 'AMD',
  Ang = 'ANG',
  Aoa = 'AOA',
  Ars = 'ARS',
  Aud = 'AUD',
  Awg = 'AWG',
  Azn = 'AZN',
  Bam = 'BAM',
  Bbd = 'BBD',
  Bdt = 'BDT',
  Bgn = 'BGN',
  Bif = 'BIF',
  Bmd = 'BMD',
  Bnd = 'BND',
  Bob = 'BOB',
  Brl = 'BRL',
  Bsd = 'BSD',
  Bwp = 'BWP',
  Bzd = 'BZD',
  Cad = 'CAD',
  Cdf = 'CDF',
  Chf = 'CHF',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Crc = 'CRC',
  Cve = 'CVE',
  Czk = 'CZK',
  Djf = 'DJF',
  Dkk = 'DKK',
  Dop = 'DOP',
  Dzd = 'DZD',
  Egp = 'EGP',
  Etb = 'ETB',
  Eur = 'EUR',
  Fjd = 'FJD',
  Fkp = 'FKP',
  Gbp = 'GBP',
  Gel = 'GEL',
  Gip = 'GIP',
  Gmd = 'GMD',
  Gnf = 'GNF',
  Gtq = 'GTQ',
  Gyd = 'GYD',
  Hkd = 'HKD',
  Hnl = 'HNL',
  Hrk = 'HRK',
  Htg = 'HTG',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Inr = 'INR',
  Isk = 'ISK',
  Jmd = 'JMD',
  Jpy = 'JPY',
  Kes = 'KES',
  Kgs = 'KGS',
  Khr = 'KHR',
  Kmf = 'KMF',
  Krw = 'KRW',
  Kyd = 'KYD',
  Kzt = 'KZT',
  Lak = 'LAK',
  Lbp = 'LBP',
  Lkr = 'LKR',
  Lrd = 'LRD',
  Lsl = 'LSL',
  Mad = 'MAD',
  Mdl = 'MDL',
  Mga = 'MGA',
  Mkd = 'MKD',
  Mmk = 'MMK',
  Mnt = 'MNT',
  Mop = 'MOP',
  Mur = 'MUR',
  Mvr = 'MVR',
  Mwk = 'MWK',
  Mxn = 'MXN',
  Myr = 'MYR',
  Mzn = 'MZN',
  Nad = 'NAD',
  Ngn = 'NGN',
  Nio = 'NIO',
  Nok = 'NOK',
  Npr = 'NPR',
  Nzd = 'NZD',
  Pab = 'PAB',
  Pen = 'PEN',
  Pgk = 'PGK',
  Php = 'PHP',
  Pkr = 'PKR',
  Pln = 'PLN',
  Pyg = 'PYG',
  Qar = 'QAR',
  Ron = 'RON',
  Rsd = 'RSD',
  Rub = 'RUB',
  Rwf = 'RWF',
  Sar = 'SAR',
  Sbd = 'SBD',
  Scr = 'SCR',
  Sek = 'SEK',
  Sgd = 'SGD',
  Shp = 'SHP',
  Sll = 'SLL',
  Srd = 'SRD',
  Std = 'STD',
  Szl = 'SZL',
  Thb = 'THB',
  Tjs = 'TJS',
  Top = 'TOP',
  Try = 'TRY',
  Ttd = 'TTD',
  Twd = 'TWD',
  Tzs = 'TZS',
  Uah = 'UAH',
  Ugx = 'UGX',
  Usd = 'USD',
  Uyu = 'UYU',
  Uzs = 'UZS',
  Vnd = 'VND',
  Vuv = 'VUV',
  Wst = 'WST',
  Xaf = 'XAF',
  Xcd = 'XCD',
  Xof = 'XOF',
  Xpf = 'XPF',
  Yer = 'YER',
  Zar = 'ZAR',
  Zmw = 'ZMW'
}

export type genCustomerEvent = {
  __typename?: 'CustomerEvent';
  cart?: Maybe<genCart>;
  created: Scalars['DateTime'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  product?: Maybe<genProduct>;
  search?: Maybe<Scalars['String']>;
  type: CustomerEventType | `${CustomerEventType}`;
};

export type genCustomerEventEdge = {
  __typename?: 'CustomerEventEdge';
  cursor: Scalars['ID'];
  node: genCustomerEvent;
};

export enum CustomerEventInputType {
  CartAdd = 'CartAdd',
  CartRemove = 'CartRemove',
  CartUpdate = 'CartUpdate',
  CategoryPageView = 'CategoryPageView',
  PageView = 'PageView',
  ProductPageView = 'ProductPageView',
  Purchase = 'Purchase',
  Search = 'Search',
  UserLeave = 'UserLeave',
  UserReturn = 'UserReturn'
}

export enum CustomerEventType {
  CartAdd = 'CartAdd',
  CartRemove = 'CartRemove',
  CategoryPageView = 'CategoryPageView',
  PageView = 'PageView',
  ProductPageView = 'ProductPageView',
  Purchase = 'Purchase',
  Search = 'Search',
  UserLeave = 'UserLeave',
  UserReturn = 'UserReturn'
}

export enum DayOfWeek {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

export type genDeleteManyResult = {
  __typename?: 'DeleteManyResult';
  count: Scalars['Int'];
};

/** affects what display types the widget will appear on */
export enum DisplayType {
  All = 'ALL',
  Desktop = 'DESKTOP',
  Mobile = 'MOBILE',
  None = 'NONE'
}

export type genEComIntegration = {
  __typename?: 'EComIntegration';
  /** The date the object was created. */
  created: Scalars['DateTime'];
  domain: Scalars['String'];
  id: Scalars['ID'];
  platform: Platform | `${Platform}`;
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
  useInventory: Scalars['Boolean'];
  vendorId: Scalars['String'];
  widgetInstallation: genWidgetInstallation;
};

export type genExpertConversationAggregateStatistics = {
  __typename?: 'ExpertConversationAggregateStatistics';
  /** The average order value of conversions attributed to chatting with this expert.       Null if the expert doesn't yet have any conversions attributed to them. */
  aovAttributed?: Maybe<Scalars['Float']>;
  /** The average time customers take to respond to a message from this expert (in seconds).       Null if the expert hasn't yet chatted with a customer. */
  averageCustomerResponseTime?: Maybe<Scalars['Float']>;
  /** The average time the expert takes to respond to a customer's message (in seconds).       Null if the expert hasn't yet chatted with a customer. */
  averageExpertResponseTime?: Maybe<Scalars['Float']>;
  /** Average word count on recommendations made in chat.       Null if the expert hasn't yet made any recommendations in chat. */
  averageRecommendationInChatWordCount?: Maybe<Scalars['Float']>;
  /** The private (for dashboard) CSAT (or customer satisfaction) score of an expert. This is the percentage of npsSurveys       that were rated positively expressed as a number between 0 & 1. Null if the expert hasn't yet been rated. */
  csatScore?: Maybe<Scalars['Float']>;
  expertId: Scalars['ID'];
  numberOfChats: Scalars['Int'];
  /** The total number of products purchased by chatters attributed to chatting with this expert. */
  numberOfProductPurchasesAttributedToChat: Scalars['Int'];
  /** The total number of products purchased by chatters attributed to a recommendation made by this expert. */
  numberOfProductPurchasesAttributedToRecommendationsInChat: Scalars['Int'];
  /** The total number of conversation segments where a customer has requested a transfer while chatting with this expert. */
  numberOfTransferRequests: Scalars['Int'];
  /** The number conversion lines that were attributed to a recommendation made in chat by this expert as a percentage of the number       of recommendations the expert has made in chat (as a number b/t 0 & 1). Null if no product purchases are attributed to this expert. */
  percentageOfRecommendationsContributingToPurchase?: Maybe<Scalars['Float']>;
  /** The products most frequently recommended by this expert in chat. */
  topRecommendedProductsInChat: Array<genProductRecommendationCount>;
  /** The total number of customer add to cart events attributed to chatting with this expert. */
  totalAddToCartsAttributed: Scalars['Int'];
  /** The total number of customer add to cart events while chatting with this expert. */
  totalAddToCartsDuringChat: Scalars['Int'];
  /** The sum of total prices on conversions attributed to chat. */
  totalValueOfAttributedConversions: Scalars['Float'];
};


export type genExpertConversationAggregateStatisticsTopRecommendedProductsInChatArgs = {
  first: Scalars['Int'];
};

export type genExpertForVendor = {
  __typename?: 'ExpertForVendor';
  /** The date the object was created. */
  created: Scalars['DateTime'];
  expert: genExpertProfile;
  id: Scalars['ID'];
  status: ExpertStatus | `${ExpertStatus}`;
  teams: Array<genTeam>;
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
  vendor: genVendor;
};

export type genExpertForVendorEdge = {
  __typename?: 'ExpertForVendorEdge';
  cursor: Scalars['ID'];
  node: genExpertForVendor;
};

export type genExpertImage = {
  __typename?: 'ExpertImage';
  /** The date the object was created. */
  created: Scalars['DateTime'];
  id: Scalars['ID'];
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
  url: Scalars['String'];
};

export type genExpertOnConversation = {
  __typename?: 'ExpertOnConversation';
  conversation: genConversation;
  /** The date the object was created. */
  created: Scalars['DateTime'];
  expert: genExpertProfile;
  id: Scalars['ID'];
  lastUpdatedForExpert: Scalars['DateTime'];
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
};

export type genExpertOnConversationEdge = {
  __typename?: 'ExpertOnConversationEdge';
  cursor: Scalars['ID'];
  node: genExpertOnConversation;
};

export type genExpertProfile = {
  __typename?: 'ExpertProfile';
  available: Scalars['Boolean'];
  avatar?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  cannedResponses: Array<genCannedResponse>;
  conversationAggregateStatistics: genExpertConversationAggregateStatistics;
  conversations: genPaginatedExpertOnConversation;
  coverPhoto?: Maybe<Scalars['String']>;
  /** The date the object was created. */
  created: Scalars['DateTime'];
  /** The public facing (sliding window) CSAT (or customer satisfaction) score of an expert. This is the percentage of npsSurveys       that were rated positively expressed as a number between 0 & 1. Null if the expert hasn't yet been rated. */
  csatScore?: Maybe<Scalars['Float']>;
  expertFacts: Array<genFactOnExpert>;
  /** @deprecated Use `publicName` instead */
  expertName?: Maybe<Scalars['String']>;
  expertsForVendor: Array<genExpertForVendor>;
  favoriteProducts: genPaginatedProduct;
  firstName?: Maybe<Scalars['String']>;
  gallery: Array<genExpertImage>;
  id: Scalars['ID'];
  /** @deprecated Use `gallery` instead */
  images: Array<Scalars['String']>;
  languages: Array<Language | `${Language}`>;
  lastName?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  online?: Maybe<Scalars['Boolean']>;
  personalLink?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  preferredGenderOfProducts?: Maybe<Gender | `${Gender}`>;
  publicName: Scalars['String'];
  publishedRecommendationGroups: genPaginatedRecommendationGroup;
  qualifications: Array<genQualification>;
  scheduleChunks: Array<genScheduleChunk>;
  skills: Array<Scalars['String']>;
  socialLinks: Array<genSocialMediaLink>;
  tagline?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
};


export type genExpertProfileConversationAggregateStatisticsArgs = {
  end?: InputMaybe<Scalars['DateTime']>;
  start?: InputMaybe<Scalars['DateTime']>;
  vendorId?: InputMaybe<Scalars['ID']>;
};


export type genExpertProfileConversationsArgs = {
  cursor?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<genConversationOnExpertFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type genExpertProfileCsatScoreArgs = {
  vendorId: Scalars['ID'];
};


export type genExpertProfileFavoriteProductsArgs = {
  cursor?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type genExpertProfileGalleryArgs = {
  take?: InputMaybe<Scalars['Int']>;
};


export type genExpertProfileImagesArgs = {
  take?: InputMaybe<Scalars['Int']>;
};


export type genExpertProfilePublishedRecommendationGroupsArgs = {
  cursor?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type genExpertProfileChatCount = {
  __typename?: 'ExpertProfileChatCount';
  expert: genExpertProfile;
  numberOfChats: Scalars['Int'];
};

/** Status of the Expert for that brand */
export enum ExpertStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type genExpertsForVendorFilterInput = {
  status?: InputMaybe<ExpertStatus | `${ExpertStatus}`>;
};

export enum ExpertsForVendorSortField {
  Created = 'created',
  Status = 'status'
}

export type genExpertsForVendorSortInput = {
  direction: SortOrder | `${SortOrder}`;
  field: ExpertsForVendorSortField | `${ExpertsForVendorSortField}`;
};

export type genFact = {
  __typename?: 'Fact';
  /** The date the object was created. */
  created: Scalars['DateTime'];
  icon: Scalars['String'];
  id: Scalars['ID'];
  prompt: Scalars['String'];
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
};

export type genFactEdge = {
  __typename?: 'FactEdge';
  cursor: Scalars['ID'];
  node: genFact;
};

export type genFactInput = {
  factId: Scalars['ID'];
  response: Scalars['String'];
};

export type genFactOnExpert = {
  __typename?: 'FactOnExpert';
  /** The date the object was created. */
  created: Scalars['DateTime'];
  factId: Scalars['ID'];
  icon: Scalars['String'];
  id: Scalars['ID'];
  prompt: Scalars['String'];
  response: Scalars['String'];
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
};

export type genFeaturedProfile = {
  __typename?: 'FeaturedProfile';
  avatar?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  publicName: Scalars['String'];
  skills: Array<Scalars['String']>;
  tagline?: Maybe<Scalars['String']>;
};

export type genFirebaseCustomResponse = {
  __typename?: 'FirebaseCustomResponse';
  token: Scalars['String'];
};

export enum Gender {
  Mens = 'Mens',
  Other = 'Other',
  Womens = 'Womens'
}

/** Permissions which may appear on a Remark staff user */
export enum GlobalPermission {
  EditBranding = 'EDIT_BRANDING',
  EditCannedResponses = 'EDIT_CANNED_RESPONSES',
  EditGlobalCannedResponses = 'EDIT_GLOBAL_CANNED_RESPONSES',
  EditIntegrations = 'EDIT_INTEGRATIONS',
  EditProducts = 'EDIT_PRODUCTS',
  EditStaffPermissions = 'EDIT_STAFF_PERMISSIONS',
  EditVendors = 'EDIT_VENDORS',
  EditVendorExperts = 'EDIT_VENDOR_EXPERTS',
  EditVendorMembers = 'EDIT_VENDOR_MEMBERS',
  EditVendorTeams = 'EDIT_VENDOR_TEAMS',
  EditWidgetSettings = 'EDIT_WIDGET_SETTINGS',
  InvokeDevOpsApiOperations = 'INVOKE_DEV_OPS_API_OPERATIONS',
  UnattributeConversions = 'UNATTRIBUTE_CONVERSIONS',
  ViewConversations = 'VIEW_CONVERSATIONS',
  ViewNps = 'VIEW_NPS',
  ViewPii = 'VIEW_PII',
  ViewVendor = 'VIEW_VENDOR'
}

export type genIdentity = {
  __typename?: 'Identity';
  chatServiceUsername?: Maybe<Scalars['String']>;
  /** The date the object was created. */
  created: Scalars['DateTime'];
  currentlyOnline: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  emailCollected: Scalars['Boolean'];
  id: Scalars['ID'];
  lead: Scalars['String'];
  suppliedFirstName?: Maybe<Scalars['String']>;
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
};

export type genImage = {
  __typename?: 'Image';
  /** The date the object was created. */
  created: Scalars['DateTime'];
  externalId: Scalars['String'];
  id: Scalars['ID'];
  position?: Maybe<Scalars['Float']>;
  productId: Scalars['String'];
  srcset?: Maybe<Scalars['String']>;
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
  url: Scalars['String'];
};

/** Affects the display type of the widget's inline activator. */
export enum InlineActivatorType {
  Expert = 'EXPERT',
  TextOnly = 'TEXT_ONLY'
}

export type genInvitation = {
  __typename?: 'Invitation';
  /** The date the object was created. */
  created: Scalars['DateTime'];
  createdBy?: Maybe<genUser>;
  email: Scalars['String'];
  expiryTime: Scalars['DateTime'];
  id: Scalars['ID'];
  invitedUser?: Maybe<genUser>;
  type: InvitationType | `${InvitationType}`;
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
  vendor?: Maybe<genVendor>;
};

export type genInvitationEdge = {
  __typename?: 'InvitationEdge';
  cursor: Scalars['ID'];
  node: genInvitation;
};

export type genInvitationFilterInput = {
  expired?: InputMaybe<Scalars['Boolean']>;
  type: InvitationType | `${InvitationType}`;
};

export enum InvitationSortField {
  Created = 'created',
  ExpiryTime = 'expiryTime'
}

export type genInvitationSortInput = {
  direction: SortOrder | `${SortOrder}`;
  field: InvitationSortField | `${InvitationSortField}`;
};

export enum InvitationType {
  Expert = 'Expert',
  VendorExpert = 'VendorExpert',
  VendorMember = 'VendorMember'
}

export type genLabelOverride = {
  __typename?: 'LabelOverride';
  /** The date the object was created. */
  created: Scalars['DateTime'];
  id: Scalars['ID'];
  key: Scalars['String'];
  /** @deprecated Naming: Use key instead. */
  label: Scalars['String'];
  language: Language | `${Language}`;
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
  value: Scalars['String'];
};

export type genLabelOverrideInput = {
  key: Scalars['String'];
  language: Language | `${Language}`;
  value: Scalars['String'];
};

/** ISO language code */
export enum Language {
  En = 'EN',
  Fr = 'FR'
}

export type genMutation = {
  __typename?: 'Mutation';
  /** Accepts the most recently terms of service. */
  acceptTermsOfService: Scalars['Boolean'];
  addExpertGalleryImage: genExpertProfile;
  addExpertToTeam: genTeam;
  addProductsToProductFamily: genProductFamily;
  addVendorMember: genVendorMembership;
  bulkUpdateProducts: Array<genProduct>;
  /** @deprecated No longer necessary for idle close functionality. */
  cancelIdleClose: genConversation;
  claimAuction?: Maybe<genConversation>;
  claimOpenConversation?: Maybe<genConversation>;
  /** Close a conversation */
  closeConversation: genConversation;
  completeSession: genRecommendationGroup;
  createCannedResponse: genCannedResponse;
  createCategory: genCategory;
  createConversation: genConversation;
  createFact: genFact;
  createInvitation: genInvitation;
  createQualification: genQualification;
  createSkills: Array<genSkill>;
  createTeam: genTeam;
  createVendor: genVendor;
  declineAuction?: Maybe<Scalars['Boolean']>;
  declineOpenConversation?: Maybe<genConversation>;
  deleteCannedResponse: genCannedResponse;
  deleteCategory: genCategory;
  deleteExpertFromTeam: genTeam;
  deleteFacts: Array<genDeleteManyResult>;
  deleteIntegration: genEComIntegration;
  deleteLabelOverrides: Scalars['Int'];
  deleteQualification: genQualification;
  deleteSkills: Array<genDeleteManyResult>;
  deleteTeam: genTeam;
  identifyLead?: Maybe<Scalars['String']>;
  installShopifyScriptTag: genEComIntegration;
  /** Records that an order occurred. Returns boolean indicating whether we've seen the conversion before or not. */
  postOrder?: Maybe<Scalars['Boolean']>;
  publishProductTagsForVendor: Scalars['Int'];
  pushAllCannedResponsesToAlgolia: Scalars['Boolean'];
  queueUnprocessedConversionsForIngestion: Scalars['Int'];
  rateRecommendation: genUserRating;
  rateRecommendationGroup: genUserRating;
  /** Add a recommendation to a conversation */
  recommendProductInConversation: genRecommendation;
  /** Records that a chatter opened their conversation on a new device by creating a chat event. */
  recordOpenedConversationOnNewDevice: genChatEvent;
  registerToken: Scalars['Boolean'];
  reingestConversions: Scalars['Boolean'];
  /**
   * CAUTION: forcibly removes the current expert from a conversation.
   *     The expertId must be supplied as a check to prove you know which expert you want removed
   */
  removeExpertFromConversation: genConversation;
  removeExpertGalleryImage: genExpertProfile;
  removeProductsFromFamily: genProductFamily;
  removeVendorMember: genVendorMembership;
  reopenConversation?: Maybe<genConversation>;
  reorderExpertGalleryImage: genExpertProfile;
  reprocessConversationSegmentAIClassification: Scalars['Boolean'];
  reprocessConversationSegments: Scalars['Boolean'];
  reprocessConversionAttributions: Scalars['Boolean'];
  revokeInvitation: genInvitation;
  saveMessageMedia: Scalars['Int'];
  sendConversionToPostHogManually: Scalars['Boolean'];
  sendEvent: Scalars['Boolean'];
  setAvailability: genExpertProfile;
  setExpertAvatar: genExpertProfile;
  setExpertCoverPhoto: genExpertProfile;
  setGlobalPermissions: genUser;
  setProductFamilyDominantProduct: genProductFamily;
  setVendorExpertStatus: Array<genExpertForVendor>;
  setVendorMemberPermissions: genVendorMembership;
  setVendorMemberRole: genVendorMembership;
  /** Mark a NPS survery as skipped */
  skipNPS: genNetPromoterScoreSurvey;
  startShopifyImport: genVendor;
  /** Generate a redirect link for a user to connect their Shopify store to our backend. */
  startShopifyInstall: Scalars['String'];
  /** Complete an NPS survey at the end of a conversation */
  submitNPS: genNetPromoterScoreSurvey;
  transferConversationViaURL?: Maybe<Scalars['String']>;
  unattributeConversion: genConversion;
  uninstallShopifyScriptTag: genEComIntegration;
  unregisterToken: Scalars['Boolean'];
  updateCannedResponse: genCannedResponse;
  updateCategory: genCategory;
  updateExpertProfile: genExpertProfile;
  updateFact: genFact;
  updateIntegration: genEComIntegration;
  updateQualification: genQualification;
  updateSkill: genSkill;
  updateTeam: genTeam;
  updateTeamPriority: Array<genTeam>;
  updateUser: genUser;
  updateVendor: genVendor;
  updateVendorBranding: genVendor;
  updateVendorLogo: genVendor;
  updateVendorSettings: genVendor;
  upsertLabelOverrides: Array<genLabelOverride>;
  useInvitation: genUser;
  userRegister: genFirebaseCustomResponse;
};


export type genMutationAcceptTermsOfServiceArgs = {
  vendorId: Scalars['ID'];
};


export type genMutationAddExpertGalleryImageArgs = {
  id: Scalars['ID'];
  image: Scalars['Upload'];
};


export type genMutationAddExpertToTeamArgs = {
  expertIds: Array<Scalars['ID']>;
  teamId: Scalars['ID'];
};


export type genMutationAddProductsToProductFamilyArgs = {
  newFamilyName?: InputMaybe<Scalars['String']>;
  productFamilyId?: InputMaybe<Scalars['ID']>;
  productIds: Array<Scalars['ID']>;
};


export type genMutationAddVendorMemberArgs = {
  userId: Scalars['ID'];
  vendorId: Scalars['ID'];
};


export type genMutationBulkUpdateProductsArgs = {
  updateProducts: Array<genUpdateProductInput>;
};


export type genMutationCancelIdleCloseArgs = {
  conversationId: Scalars['ID'];
  lead?: InputMaybe<Scalars['String']>;
};


export type genMutationClaimAuctionArgs = {
  auctionId: Scalars['String'];
  conversationId: Scalars['ID'];
};


export type genMutationClaimOpenConversationArgs = {
  conversationId: Scalars['ID'];
};


export type genMutationCloseConversationArgs = {
  chatServiceId?: InputMaybe<Scalars['String']>;
  conversationId?: InputMaybe<Scalars['ID']>;
};


export type genMutationCompleteSessionArgs = {
  answers: Array<genAnswerInput>;
  fakeData?: InputMaybe<Scalars['Boolean']>;
  lead?: InputMaybe<Scalars['String']>;
  quizId: Scalars['ID'];
};


export type genMutationCreateCannedResponseArgs = {
  body: Scalars['String'];
  expertId?: InputMaybe<Scalars['ID']>;
  images?: InputMaybe<Array<Scalars['Upload']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  type?: InputMaybe<CannedContentType>;
  vendorId?: InputMaybe<Scalars['ID']>;
};


export type genMutationCreateCategoryArgs = {
  name: Scalars['String'];
  productIds: Array<Scalars['ID']>;
  vendorId: Scalars['ID'];
};


export type genMutationCreateConversationArgs = {
  lead?: InputMaybe<Scalars['String']>;
  vendorId: Scalars['ID'];
};


export type genMutationCreateFactArgs = {
  icon: Scalars['String'];
  prompt: Scalars['String'];
};


export type genMutationCreateInvitationArgs = {
  email: Scalars['String'];
  invitationType: InvitationType;
  vendorId?: InputMaybe<Scalars['ID']>;
};


export type genMutationCreateQualificationArgs = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  expertId?: InputMaybe<Scalars['ID']>;
  icon: Scalars['String'];
  role?: InputMaybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  title: Scalars['String'];
};


export type genMutationCreateSkillsArgs = {
  titles: Array<Scalars['String']>;
};


export type genMutationCreateTeamArgs = {
  auctionPriority?: InputMaybe<Scalars['Int']>;
  canViewIdentityEmails?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Scalars['String']>;
  expertIds?: InputMaybe<Array<Scalars['ID']>>;
  name: Scalars['String'];
  vendorId: Scalars['ID'];
};


export type genMutationCreateVendorArgs = {
  faqLink?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  publish?: InputMaybe<Scalars['Boolean']>;
  shopUrl: Scalars['String'];
  slug: Scalars['String'];
  supportLink?: InputMaybe<Scalars['String']>;
};


export type genMutationDeclineAuctionArgs = {
  auctionId: Scalars['String'];
  conversationId: Scalars['ID'];
};


export type genMutationDeclineOpenConversationArgs = {
  conversationId: Scalars['ID'];
};


export type genMutationDeleteCannedResponseArgs = {
  id: Scalars['ID'];
};


export type genMutationDeleteCategoryArgs = {
  id: Scalars['ID'];
};


export type genMutationDeleteExpertFromTeamArgs = {
  expertIds: Array<Scalars['ID']>;
  teamId: Scalars['ID'];
};


export type genMutationDeleteFactsArgs = {
  ids: Array<Scalars['ID']>;
};


export type genMutationDeleteIntegrationArgs = {
  platform: Platform;
  vendorId: Scalars['ID'];
};


export type genMutationDeleteLabelOverridesArgs = {
  labelOverrideIds: Array<Scalars['ID']>;
  vendorId: Scalars['ID'];
};


export type genMutationDeleteQualificationArgs = {
  id: Array<Scalars['ID']>;
};


export type genMutationDeleteSkillsArgs = {
  ids: Array<Scalars['ID']>;
};


export type genMutationDeleteTeamArgs = {
  teamId: Scalars['ID'];
};


export type genMutationIdentifyLeadArgs = {
  conversationId?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lead: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  requestMessageId?: InputMaybe<Scalars['String']>;
};


export type genMutationInstallShopifyScriptTagArgs = {
  integrationId: Scalars['ID'];
};


export type genMutationPostOrderArgs = {
  lead?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Platform>;
  rawData: Scalars['String'];
  shopUrl: Scalars['String'];
};


export type genMutationPublishProductTagsForVendorArgs = {
  isPublic: Scalars['Boolean'];
  tagIds: Array<Scalars['ID']>;
  vendorId: Scalars['ID'];
};


export type genMutationRateRecommendationArgs = {
  lead: Scalars['String'];
  rating: Scalars['Int'];
  recommendationGroupId?: InputMaybe<Scalars['ID']>;
  recommendationId?: InputMaybe<Scalars['ID']>;
};


export type genMutationRateRecommendationGroupArgs = {
  lead: Scalars['String'];
  rating: Scalars['Int'];
  recommendationGroupId?: InputMaybe<Scalars['ID']>;
  recommendationId?: InputMaybe<Scalars['ID']>;
};


export type genMutationRecommendProductInConversationArgs = {
  conversationId: Scalars['ID'];
  recommendation: genRecommendationInput;
};


export type genMutationRecordOpenedConversationOnNewDeviceArgs = {
  conversationId: Scalars['ID'];
  lead: Scalars['String'];
  transferType: ConversationDeviceTransferType;
};


export type genMutationRegisterTokenArgs = {
  platform: NotificationPlatform;
  token: Scalars['String'];
};


export type genMutationReingestConversionsArgs = {
  conversionIds?: InputMaybe<Array<Scalars['ID']>>;
  performForAll: Scalars['Boolean'];
};


export type genMutationRemoveExpertFromConversationArgs = {
  conversationId: Scalars['ID'];
  expertId: Scalars['ID'];
};


export type genMutationRemoveExpertGalleryImageArgs = {
  imageId: Scalars['ID'];
};


export type genMutationRemoveProductsFromFamilyArgs = {
  productIds: Array<Scalars['ID']>;
};


export type genMutationRemoveVendorMemberArgs = {
  userId: Scalars['ID'];
  vendorId: Scalars['ID'];
};


export type genMutationReopenConversationArgs = {
  conversationId: Scalars['ID'];
  lead: Scalars['String'];
};


export type genMutationReorderExpertGalleryImageArgs = {
  imageId: Scalars['ID'];
  position: Scalars['Int'];
};


export type genMutationReprocessConversationSegmentAiClassificationArgs = {
  closedChatEventIds?: InputMaybe<Array<Scalars['ID']>>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};


export type genMutationReprocessConversationSegmentsArgs = {
  closedChatEventIds: Array<Scalars['ID']>;
};


export type genMutationReprocessConversionAttributionsArgs = {
  conversionIds: Array<Scalars['ID']>;
};


export type genMutationRevokeInvitationArgs = {
  invitationId: Scalars['ID'];
};


export type genMutationSaveMessageMediaArgs = {
  chatServiceEventId: Scalars['String'];
  filepaths: Array<Scalars['String']>;
};


export type genMutationSendConversionToPostHogManuallyArgs = {
  conversionId: Scalars['ID'];
};


export type genMutationSendEventArgs = {
  sendEventInput: genCreateCustomerEventInput;
};


export type genMutationSetAvailabilityArgs = {
  available: Scalars['Boolean'];
};


export type genMutationSetExpertAvatarArgs = {
  avatar: Scalars['Upload'];
  id: Scalars['ID'];
};


export type genMutationSetExpertCoverPhotoArgs = {
  coverPhoto: Scalars['Upload'];
  id: Scalars['ID'];
};


export type genMutationSetGlobalPermissionsArgs = {
  permissions: Array<AssignableGlobalPermission>;
  userId: Scalars['ID'];
};


export type genMutationSetProductFamilyDominantProductArgs = {
  productFamilyId: Scalars['ID'];
  productId: Scalars['ID'];
};


export type genMutationSetVendorExpertStatusArgs = {
  expertIds: Array<Scalars['ID']>;
  status: ExpertStatus;
  vendorId: Scalars['ID'];
};


export type genMutationSetVendorMemberPermissionsArgs = {
  permissions: Array<AssignableVendorPermission>;
  userId: Scalars['ID'];
  vendorId: Scalars['ID'];
};


export type genMutationSetVendorMemberRoleArgs = {
  newRole: VendorMembershipRole;
  userId: Scalars['ID'];
  vendorId: Scalars['ID'];
};


export type genMutationSkipNpsArgs = {
  lead: Scalars['String'];
  npsSurveyId: Scalars['ID'];
};


export type genMutationStartShopifyImportArgs = {
  vendorId: Scalars['ID'];
};


export type genMutationStartShopifyInstallArgs = {
  shopifyDomain: Scalars['String'];
  vendorId: Scalars['ID'];
};


export type genMutationSubmitNpsArgs = {
  additionalNotes?: InputMaybe<Scalars['String']>;
  lead: Scalars['String'];
  npsSurveyId: Scalars['ID'];
  rating: Scalars['Int'];
  tag?: InputMaybe<NpsTag>;
};


export type genMutationTransferConversationViaUrlArgs = {
  conversationId: Scalars['ID'];
  lead: Scalars['String'];
};


export type genMutationUnattributeConversionArgs = {
  conversionId: Scalars['ID'];
};


export type genMutationUninstallShopifyScriptTagArgs = {
  integrationId: Scalars['ID'];
};


export type genMutationUnregisterTokenArgs = {
  token: Scalars['String'];
};


export type genMutationUpdateCannedResponseArgs = {
  body?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  imagesToDelete?: InputMaybe<Array<Scalars['ID']>>;
  imagesToUpload?: InputMaybe<Array<Scalars['Upload']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CannedContentType>;
};


export type genMutationUpdateCategoryArgs = {
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  productIdsToAdd?: InputMaybe<Array<Scalars['ID']>>;
  productIdsToRemove?: InputMaybe<Array<Scalars['ID']>>;
};


export type genMutationUpdateExpertProfileArgs = {
  bio?: InputMaybe<Scalars['String']>;
  facts?: InputMaybe<Array<genFactInput>>;
  favoriteProductIdsToAdd?: InputMaybe<Array<Scalars['ID']>>;
  favoriteProductIdsToRemove?: InputMaybe<Array<Scalars['ID']>>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  languages?: InputMaybe<Array<Language>>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  preferredGenderOfProducts?: InputMaybe<Gender>;
  qualificationsToCreate?: InputMaybe<Array<genQualificationsToCreateInput>>;
  qualificationsToDelete?: InputMaybe<Array<Scalars['ID']>>;
  qualificationsToUpdate?: InputMaybe<Array<genQualificationsToUpdateInput>>;
  scheduleChunks?: InputMaybe<Array<genScheduleChunkInput>>;
  skillTitles?: InputMaybe<Array<Scalars['String']>>;
  socials?: InputMaybe<genSocialLinkInput>;
  tagline?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type genMutationUpdateFactArgs = {
  icon?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  prompt?: InputMaybe<Scalars['String']>;
};


export type genMutationUpdateIntegrationArgs = {
  platform: Platform;
  useInventory?: InputMaybe<Scalars['Boolean']>;
  vendorId: Scalars['String'];
};


export type genMutationUpdateQualificationArgs = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  icon?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  role?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
};


export type genMutationUpdateSkillArgs = {
  id: Scalars['ID'];
  title: Scalars['String'];
};


export type genMutationUpdateTeamArgs = {
  auctionPriority?: InputMaybe<Scalars['Int']>;
  canViewIdentityEmails?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  teamId: Scalars['ID'];
};


export type genMutationUpdateTeamPriorityArgs = {
  teams: Array<genTeamPriorityInput>;
};


export type genMutationUpdateUserArgs = {
  userId?: InputMaybe<Scalars['ID']>;
  userUpdateInput: genUserUpdateInput;
};


export type genMutationUpdateVendorArgs = {
  update: genVendorUpdateInput;
  vendorId: Scalars['ID'];
};


export type genMutationUpdateVendorBrandingArgs = {
  update: genUpdateVendorBrandingInput;
  vendorId: Scalars['ID'];
};


export type genMutationUpdateVendorLogoArgs = {
  image: Scalars['Upload'];
  vendorId: Scalars['ID'];
};


export type genMutationUpdateVendorSettingsArgs = {
  update: genUpdateVendorSettingsInput;
  vendorId: Scalars['ID'];
};


export type genMutationUpsertLabelOverridesArgs = {
  labelOverrides: Array<genLabelOverrideInput>;
  vendorId: Scalars['ID'];
};


export type genMutationUseInvitationArgs = {
  invitationCode: Scalars['String'];
};


export type genMutationUserRegisterArgs = {
  email: Scalars['String'];
  invitationCode: Scalars['String'];
  password: Scalars['String'];
};

export enum NpsTag {
  ChattingToolEasyToUse = 'ChattingToolEasyToUse',
  Condescending = 'Condescending',
  DidntConsiderBudget = 'DidntConsiderBudget',
  DidntGetEnoughInformation = 'DidntGetEnoughInformation',
  DidntHaveWhatIWasLookingFor = 'DidntHaveWhatIWasLookingFor',
  DidntLikeProduct = 'DidntLikeProduct',
  ExpertListened = 'ExpertListened',
  ExpertNotKnowledgeable = 'ExpertNotKnowledgeable',
  ExpertWasKnowledgeable = 'ExpertWasKnowledgeable',
  Friendly = 'Friendly',
  Impersonal = 'Impersonal',
  IrrelevantRecommendations = 'IrrelevantRecommendations',
  Pushy = 'Pushy',
  QualityRecommendations = 'QualityRecommendations',
  RespondedQuickly = 'RespondedQuickly',
  RespondedSlowly = 'RespondedSlowly',
  Unprofessional = 'Unprofessional',
  WaitedTooLong = 'WaitedTooLong'
}

export type genNetPromoterScoreSurvey = {
  __typename?: 'NetPromoterScoreSurvey';
  additionalNotes?: Maybe<Scalars['String']>;
  completed: Scalars['Boolean'];
  /** The date the object was created. */
  created: Scalars['DateTime'];
  expert: genExpertProfile;
  id: Scalars['ID'];
  identity: genIdentity;
  rating?: Maybe<Scalars['Int']>;
  /** indicates whether the survey has ever been skipped, not whether its current status is "skipped" */
  skipped: Scalars['Boolean'];
  tag?: Maybe<NpsTag | `${NpsTag}`>;
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
  vendor: genVendor;
};

export enum NotificationPlatform {
  Android = 'android',
  Ios = 'ios',
  Web = 'web'
}

export type genOfferedConversation = {
  __typename?: 'OfferedConversation';
  availableExperts: Scalars['Float'];
  conversationSid?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  vendor: genVendor;
  vendorId: Scalars['String'];
};

export type genPaginatedCategory = {
  __typename?: 'PaginatedCategory';
  edges: Array<genCategoryEdge>;
  endCursor?: Maybe<Scalars['ID']>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  nodes: Array<genCategory>;
  startCursor?: Maybe<Scalars['ID']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type genPaginatedChatEvent = {
  __typename?: 'PaginatedChatEvent';
  edges: Array<genChatEventEdge>;
  endCursor?: Maybe<Scalars['ID']>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  nodes: Array<genChatEvent>;
  startCursor?: Maybe<Scalars['ID']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type genPaginatedConversation = {
  __typename?: 'PaginatedConversation';
  edges: Array<genConversationEdge>;
  endCursor?: Maybe<Scalars['ID']>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  nodes: Array<genConversation>;
  startCursor?: Maybe<Scalars['ID']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type genPaginatedConversion = {
  __typename?: 'PaginatedConversion';
  edges: Array<genConversionEdge>;
  endCursor?: Maybe<Scalars['ID']>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  nodes: Array<genConversion>;
  startCursor?: Maybe<Scalars['ID']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type genPaginatedCustomerEvent = {
  __typename?: 'PaginatedCustomerEvent';
  edges: Array<genCustomerEventEdge>;
  endCursor?: Maybe<Scalars['ID']>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  nodes: Array<genCustomerEvent>;
  startCursor?: Maybe<Scalars['ID']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type genPaginatedExpertForVendor = {
  __typename?: 'PaginatedExpertForVendor';
  edges: Array<genExpertForVendorEdge>;
  endCursor?: Maybe<Scalars['ID']>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  nodes: Array<genExpertForVendor>;
  startCursor?: Maybe<Scalars['ID']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type genPaginatedExpertOnConversation = {
  __typename?: 'PaginatedExpertOnConversation';
  edges: Array<genExpertOnConversationEdge>;
  endCursor?: Maybe<Scalars['ID']>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  nodes: Array<genExpertOnConversation>;
  startCursor?: Maybe<Scalars['ID']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type genPaginatedFact = {
  __typename?: 'PaginatedFact';
  edges: Array<genFactEdge>;
  endCursor?: Maybe<Scalars['ID']>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  nodes: Array<genFact>;
  startCursor?: Maybe<Scalars['ID']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type genPaginatedInvitation = {
  __typename?: 'PaginatedInvitation';
  edges: Array<genInvitationEdge>;
  endCursor?: Maybe<Scalars['ID']>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  nodes: Array<genInvitation>;
  startCursor?: Maybe<Scalars['ID']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type genPaginatedProduct = {
  __typename?: 'PaginatedProduct';
  edges: Array<genProductEdge>;
  endCursor?: Maybe<Scalars['ID']>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  nodes: Array<genProduct>;
  startCursor?: Maybe<Scalars['ID']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type genPaginatedProductFamily = {
  __typename?: 'PaginatedProductFamily';
  edges: Array<genProductFamilyEdge>;
  endCursor?: Maybe<Scalars['ID']>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  nodes: Array<genProductFamily>;
  startCursor?: Maybe<Scalars['ID']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type genPaginatedRecommendation = {
  __typename?: 'PaginatedRecommendation';
  edges: Array<genRecommendationEdge>;
  endCursor?: Maybe<Scalars['ID']>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  nodes: Array<genRecommendation>;
  startCursor?: Maybe<Scalars['ID']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type genPaginatedRecommendationGroup = {
  __typename?: 'PaginatedRecommendationGroup';
  edges: Array<genRecommendationGroupEdge>;
  endCursor?: Maybe<Scalars['ID']>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  nodes: Array<genRecommendationGroup>;
  startCursor?: Maybe<Scalars['ID']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type genPaginatedSession = {
  __typename?: 'PaginatedSession';
  edges: Array<genSessionEdge>;
  endCursor?: Maybe<Scalars['ID']>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  nodes: Array<genSession>;
  startCursor?: Maybe<Scalars['ID']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type genPaginatedSkill = {
  __typename?: 'PaginatedSkill';
  edges: Array<genSkillEdge>;
  endCursor?: Maybe<Scalars['ID']>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  nodes: Array<genSkill>;
  startCursor?: Maybe<Scalars['ID']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type genPaginatedVendor = {
  __typename?: 'PaginatedVendor';
  edges: Array<genVendorEdge>;
  endCursor?: Maybe<Scalars['ID']>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  nodes: Array<genVendor>;
  startCursor?: Maybe<Scalars['ID']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export enum Platform {
  BigCommerce = 'BigCommerce',
  Generic = 'Generic',
  Magento = 'Magento',
  Shopify = 'Shopify'
}

export type genPossiblyContextualizedRecommendation = {
  __typename?: 'PossiblyContextualizedRecommendation';
  isContextualized: Scalars['Boolean'];
  recommendation?: Maybe<genRecommendation>;
};

export type genPrice = {
  __typename?: 'Price';
  compareAtPrice?: Maybe<Scalars['Float']>;
  /** The date the object was created. */
  created: Scalars['DateTime'];
  currency: Currency | `${Currency}`;
  id: Scalars['ID'];
  price: Scalars['Float'];
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
};

export type genProduct = {
  __typename?: 'Product';
  allTags: Array<genProductTag>;
  brandName: Scalars['String'];
  categories: genPaginatedCategory;
  compareAtPrice?: Maybe<genPrice>;
  /** The date the object was created. */
  created: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  externalUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  images: Array<genImage>;
  isInMyFavorites?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  price?: Maybe<genPrice>;
  publicTags: Array<genProductTag>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** The total stock quantity of all the product's variants (with non-negative stock quantity) if we're pulling inventory from the vendor. Null if we're not. */
  quantity?: Maybe<Scalars['Int']>;
  recommendations: genPaginatedRecommendation;
  upc?: Maybe<Scalars['String']>;
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
  variants: Array<genVariant>;
};


export type genProductCategoriesArgs = {
  cursor?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type genProductImagesArgs = {
  take?: InputMaybe<Scalars['Int']>;
};


export type genProductPriceArgs = {
  currency: Currency;
};


export type genProductRecommendationsArgs = {
  cursor?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type genProductVariantsArgs = {
  filter?: InputMaybe<genProductVariantFilterInput>;
};

export type genProductEdge = {
  __typename?: 'ProductEdge';
  cursor: Scalars['ID'];
  node: genProduct;
};

export type genProductFamily = {
  __typename?: 'ProductFamily';
  /** The date the object was created. */
  created: Scalars['DateTime'];
  dominantProduct?: Maybe<genProduct>;
  id: Scalars['ID'];
  name: Scalars['String'];
  products: Array<genProduct>;
  shareRecommendationsAcrossGenerations: Scalars['Boolean'];
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
  vendor: genVendor;
};

export type genProductFamilyEdge = {
  __typename?: 'ProductFamilyEdge';
  cursor: Scalars['ID'];
  node: genProductFamily;
};

export type genProductFilterInput = {
  /** Names of categories that we want to filter products by */
  categoryNames?: InputMaybe<Array<Scalars['String']>>;
  /** Where to show archived or non-archived products. Leave undefined to see both. */
  isArchived?: InputMaybe<Scalars['Boolean']>;
  /** Whether to show published or unpublished products.  Leave undefined to see both */
  isPublished?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type genProductRecommendationCount = {
  __typename?: 'ProductRecommendationCount';
  numberOfTimesRecommended: Scalars['Int'];
  /** The number of this product that has been purchased. */
  numberPurchased: Scalars['Int'];
  product: genProduct;
};

export type genProductTag = {
  __typename?: 'ProductTag';
  /** The date the object was created. */
  created: Scalars['DateTime'];
  id: Scalars['ID'];
  isPublic: Scalars['Boolean'];
  name: Scalars['String'];
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
};

export type genProductVariantFilterInput = {
  variantIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type genQualification = {
  __typename?: 'Qualification';
  /** The date the object was created. */
  created: Scalars['DateTime'];
  endDate?: Maybe<Scalars['DateTime']>;
  expert: genExpertProfile;
  icon: Scalars['String'];
  id: Scalars['ID'];
  role?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  title: Scalars['String'];
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
};

export type genQualificationsToCreateInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  icon: Scalars['String'];
  role?: InputMaybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  title: Scalars['String'];
};

export type genQualificationsToUpdateInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  icon?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  role?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
};

export type genQuery = {
  __typename?: 'Query';
  cannedResponseById: genCannedResponse;
  cannedResponseTags: Array<Scalars['String']>;
  /** Get the chat service access token for the current user */
  chatServiceAccessToken?: Maybe<Scalars['String']>;
  /** Get a conversation by id or by chatServiceId */
  conversation?: Maybe<genConversation>;
  conversations: genPaginatedConversation;
  conversion?: Maybe<genConversion>;
  currentVendorTermsOfService: genVendorTermsOfService;
  customerEvent: Array<genCustomerEvent>;
  expertProfile?: Maybe<genExpertProfile>;
  facts: genPaginatedFact;
  getChatEvent: genChatEvent;
  globalCannedResponses: Array<genCannedResponse>;
  hasOwnerAcceptedToS: Scalars['Boolean'];
  invitations: genPaginatedInvitation;
  invitationsOnVendor: genPaginatedInvitation;
  me?: Maybe<genUser>;
  /** Get an NPS Survey by id */
  npsSurveyById?: Maybe<genNetPromoterScoreSurvey>;
  numberOfAvailableExpertsOnVendor: Scalars['Int'];
  /** Get all conversations available to the current user */
  offeredConversations: Array<genOfferedConversation>;
  /** Get all running auctions for the current user */
  openAuctions: Array<genAuction>;
  product?: Maybe<genProduct>;
  productFamilies: genPaginatedProductFamily;
  /** Attempts to retrieve a context sensitive recommendation given a productId and a lead. Defaults to a generic recommendation for the product if unsuccessful. May return no recommendation. */
  productRecommendation?: Maybe<genPossiblyContextualizedRecommendation>;
  products: genPaginatedProduct;
  publicRecommendations: genPaginatedRecommendation;
  recommendation?: Maybe<genRecommendation>;
  recommendationGroup?: Maybe<genRecommendationGroup>;
  recommendationGroups: genPaginatedRecommendationGroup;
  session?: Maybe<genSession>;
  sessionByVendorId?: Maybe<genSession>;
  sessionsOnVendor: genPaginatedSession;
  skills: genPaginatedSkill;
  team: genTeam;
  vendor?: Maybe<genVendor>;
  vendorById?: Maybe<genVendor>;
  vendorExpert: genExpertForVendor;
  vendorMember: genVendorMembership;
  vendors: genPaginatedVendor;
};


export type genQueryCannedResponseByIdArgs = {
  cannedResponseId?: InputMaybe<Scalars['String']>;
};


export type genQueryCannedResponseTagsArgs = {
  vendorId?: InputMaybe<Scalars['String']>;
};


export type genQueryChatServiceAccessTokenArgs = {
  lead?: InputMaybe<Scalars['String']>;
};


export type genQueryConversationArgs = {
  chatServiceId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  lead?: InputMaybe<Scalars['String']>;
};


export type genQueryConversationsArgs = {
  cursor?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<Array<genConversationFilterInput>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<genConversationSortInput>>;
  vendorId: Scalars['ID'];
};


export type genQueryConversionArgs = {
  id: Scalars['ID'];
};


export type genQueryCustomerEventArgs = {
  chatServiceId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  vendorId: Scalars['ID'];
};


export type genQueryExpertProfileArgs = {
  id: Scalars['ID'];
};


export type genQueryFactsArgs = {
  cursor?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type genQueryGetChatEventArgs = {
  id: Scalars['String'];
};


export type genQueryHasOwnerAcceptedToSArgs = {
  vendorId: Scalars['ID'];
};


export type genQueryInvitationsArgs = {
  cursor?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type genQueryInvitationsOnVendorArgs = {
  cursor?: InputMaybe<Scalars['ID']>;
  filter: genInvitationFilterInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<genInvitationSortInput>>;
  vendorId: Scalars['ID'];
};


export type genQueryNpsSurveyByIdArgs = {
  lead?: InputMaybe<Scalars['String']>;
  surveyId: Scalars['ID'];
};


export type genQueryNumberOfAvailableExpertsOnVendorArgs = {
  vendorId: Scalars['ID'];
};


export type genQueryProductArgs = {
  id: Scalars['ID'];
};


export type genQueryProductFamiliesArgs = {
  cursor?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  vendorId: Scalars['ID'];
};


export type genQueryProductRecommendationArgs = {
  lead: Scalars['String'];
  productId: Scalars['ID'];
  shopUrl: Scalars['String'];
};


export type genQueryProductsArgs = {
  cursor?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<genProductFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  vendorId?: InputMaybe<Scalars['ID']>;
};


export type genQueryPublicRecommendationsArgs = {
  cursor?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type genQueryRecommendationArgs = {
  id: Scalars['ID'];
};


export type genQueryRecommendationGroupArgs = {
  id: Scalars['ID'];
};


export type genQueryRecommendationGroupsArgs = {
  cursor?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type genQuerySessionArgs = {
  lead?: InputMaybe<Scalars['String']>;
  shopUrl: Scalars['String'];
};


export type genQuerySessionByVendorIdArgs = {
  lead: Scalars['String'];
  vendorId: Scalars['ID'];
};


export type genQuerySessionsOnVendorArgs = {
  cursor?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<genSessionFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<genSessionSortInput>>;
  vendorId?: InputMaybe<Scalars['ID']>;
};


export type genQuerySkillsArgs = {
  cursor?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<genSkillFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type genQueryTeamArgs = {
  teamId: Scalars['ID'];
};


export type genQueryVendorArgs = {
  shopUrl: Scalars['String'];
};


export type genQueryVendorByIdArgs = {
  slug?: InputMaybe<Scalars['String']>;
  vendorId?: InputMaybe<Scalars['ID']>;
};


export type genQueryVendorExpertArgs = {
  expertId: Scalars['ID'];
  vendorId: Scalars['ID'];
};


export type genQueryVendorMemberArgs = {
  userId: Scalars['ID'];
  vendorId: Scalars['ID'];
};


export type genQueryVendorsArgs = {
  cursor?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<Array<genVendorFilterInput>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type genQuiz = {
  __typename?: 'Quiz';
  /** The date the object was created. */
  created: Scalars['DateTime'];
  heyflowId: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
};

export type genRecommendation = {
  __typename?: 'Recommendation';
  /** When this recommendation was approved. */
  approvedAt?: Maybe<Scalars['DateTime']>;
  /** The staff member who approved this recommendation. */
  approvedBy?: Maybe<genUser>;
  body: Scalars['String'];
  /** The date the object was created. */
  created: Scalars['DateTime'];
  headline: Scalars['String'];
  id: Scalars['ID'];
  /** The recommended product */
  product?: Maybe<genProduct>;
  /**
   * The ID of the recommended product.
   * Compare to the `product` field's id when using getDominantProduct to determine whether a
   * different (or dominant) product is currently recommended.
   */
  productId?: Maybe<Scalars['String']>;
  /** The avatar of the entity recommending an item */
  recommenderAvatar?: Maybe<Scalars['String']>;
  /** The expert profile id of the recommender */
  recommenderId?: Maybe<Scalars['String']>;
  /** A external link, to the entity recommending an item */
  recommenderLink?: Maybe<Scalars['String']>;
  /** The name of the entity recommending an item */
  recommenderName?: Maybe<Scalars['String']>;
  /** The tagline, if existing, of the entity recommending an item */
  recommenderTagline?: Maybe<Scalars['String']>;
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
  /** Search for a rating on this recommendation by lead */
  userRating?: Maybe<genUserRating>;
  /** The recommended variant */
  variant?: Maybe<genVariant>;
};


export type genRecommendationProductArgs = {
  getDominantProduct?: InputMaybe<Scalars['Boolean']>;
};


export type genRecommendationUserRatingArgs = {
  lead: Scalars['String'];
};

export type genRecommendationEdge = {
  __typename?: 'RecommendationEdge';
  cursor: Scalars['ID'];
  node: genRecommendation;
};

export type genRecommendationGroup = {
  __typename?: 'RecommendationGroup';
  /** The date the object was created. */
  created: Scalars['DateTime'];
  /** The avatar of the groups creator */
  creatorAvatar?: Maybe<Scalars['String']>;
  /** The ID of the groups creator */
  creatorId?: Maybe<Scalars['String']>;
  /** The name of the groups creator */
  creatorName?: Maybe<Scalars['String']>;
  /** The creator's tagline */
  creatorTagline?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  /** The recommendations in this group. */
  recommendations: Array<genRecommendation>;
  /** The thumbnail for this group */
  thumbnail?: Maybe<Scalars['String']>;
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
  /** Search for a rating on this group by lead */
  userRating?: Maybe<genUserRating>;
};


export type genRecommendationGroupUserRatingArgs = {
  lead: Scalars['String'];
};

export type genRecommendationGroupEdge = {
  __typename?: 'RecommendationGroupEdge';
  cursor: Scalars['ID'];
  node: genRecommendationGroup;
};

export type genRecommendationInput = {
  body?: InputMaybe<Scalars['String']>;
  headline?: InputMaybe<Scalars['String']>;
  productId: Scalars['ID'];
  variantId?: InputMaybe<Scalars['ID']>;
};

export enum RecommendationSortField {
  Created = 'created'
}

export type genRecommendationSortInput = {
  direction: SortOrder | `${SortOrder}`;
  field: RecommendationSortField | `${RecommendationSortField}`;
};

export enum Role {
  Admin = 'ADMIN',
  Staff = 'STAFF',
  User = 'USER'
}

export type genScheduleChunk = {
  __typename?: 'ScheduleChunk';
  created: Scalars['DateTime'];
  dayOfWeek: DayOfWeek | `${DayOfWeek}`;
  endTime: Scalars['String'];
  id: Scalars['ID'];
  startTime: Scalars['String'];
};

export type genScheduleChunkInput = {
  dayOfWeek: DayOfWeek | `${DayOfWeek}`;
  endTime: Scalars['String'];
  startTime: Scalars['String'];
};

export type genSession = {
  __typename?: 'Session';
  /** The time at which the session was completed. */
  completedAt?: Maybe<Scalars['DateTime']>;
  conversions: genPaginatedConversion;
  /** The date the object was created. */
  created: Scalars['DateTime'];
  customerEvents: genPaginatedCustomerEvent;
  id: Scalars['ID'];
  identity?: Maybe<genIdentity>;
  isControlGroup: Scalars['Boolean'];
  /** Whether the session has been associated with identifying user details (email or phone). */
  isIdentified: Scalars['Boolean'];
  lastPageVisited?: Maybe<Scalars['String']>;
  lastSeen?: Maybe<Scalars['DateTime']>;
  lastUserAgent?: Maybe<genUserAgent>;
  lead: Scalars['String'];
  /** The total value of all of this identity's conversions in USD. */
  lifetimeValue: Scalars['Float'];
  /**
   * the "open" part of this field has nothing to do with the status of the conversation,
   * but rather whether a conversation exists at all for this session
   */
  openConversation?: Maybe<genConversation>;
  recommendationGroups: Array<genRecommendationGroup>;
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
  vendor: genVendor;
  vendorLiftTestId?: Maybe<Scalars['String']>;
};


export type genSessionConversionsArgs = {
  cursor?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type genSessionCustomerEventsArgs = {
  cursor?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  types?: InputMaybe<Array<CustomerEventType>>;
};

export type genSessionEdge = {
  __typename?: 'SessionEdge';
  cursor: Scalars['ID'];
  node: genSession;
};

export type genSessionFilterInput = {
  hasConversation?: InputMaybe<Scalars['Boolean']>;
};

export enum SessionSortField {
  Created = 'created'
}

export type genSessionSortInput = {
  direction: SortOrder | `${SortOrder}`;
  field: SessionSortField | `${SessionSortField}`;
};

export type genSkill = {
  __typename?: 'Skill';
  /** The date the object was created. */
  created: Scalars['DateTime'];
  id: Scalars['ID'];
  title: Scalars['String'];
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
};

export type genSkillEdge = {
  __typename?: 'SkillEdge';
  cursor: Scalars['ID'];
  node: genSkill;
};

export type genSkillFilterInput = {
  title?: InputMaybe<Scalars['String']>;
};

export type genSocialLinkInput = {
  facebookUsername?: InputMaybe<Scalars['String']>;
  instagramUsername?: InputMaybe<Scalars['String']>;
  linkedinUsername?: InputMaybe<Scalars['String']>;
  personalLink?: InputMaybe<Scalars['String']>;
  pinterestUsername?: InputMaybe<Scalars['String']>;
  redditUsername?: InputMaybe<Scalars['String']>;
  spotifyUsername?: InputMaybe<Scalars['String']>;
  tiktokUsername?: InputMaybe<Scalars['String']>;
  tumblrUsername?: InputMaybe<Scalars['String']>;
  twitterUsername?: InputMaybe<Scalars['String']>;
  vimeoUsername?: InputMaybe<Scalars['String']>;
  youtubeUsername?: InputMaybe<Scalars['String']>;
};

export type genSocialMediaLink = {
  __typename?: 'SocialMediaLink';
  link?: Maybe<Scalars['String']>;
  socialMediaNetworkName: SocialNetwork | `${SocialNetwork}`;
  username?: Maybe<Scalars['String']>;
};

export enum SocialNetwork {
  Facebook = 'Facebook',
  Instagram = 'Instagram',
  LinkedIn = 'LinkedIn',
  Pinterest = 'Pinterest',
  Reddit = 'Reddit',
  Spotify = 'Spotify',
  TikTok = 'TikTok',
  Tumblr = 'Tumblr',
  Twitter = 'Twitter',
  Vimeo = 'Vimeo',
  YouTube = 'YouTube'
}

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type genSubscription = {
  __typename?: 'Subscription';
  /** Subscribe to auctions */
  auctionEvent: genAuctionEvent;
  /** Subscribe to a Conversation by ID */
  conversation: genConversation;
  /** Subscribe to new chat events on a conversation */
  conversationChatEvent: genChatEvent;
  /** Subscribe to conversation offers */
  conversationOfferEvent: genConversationOfferEvent;
  customerEvent: genCustomerEvent;
};


export type genSubscriptionConversationArgs = {
  chatServiceId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  lead?: InputMaybe<Scalars['String']>;
};


export type genSubscriptionConversationChatEventArgs = {
  conversationId: Scalars['ID'];
  lead: Scalars['ID'];
};


export type genSubscriptionCustomerEventArgs = {
  chatServiceId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  vendorId: Scalars['ID'];
};

export type genTeam = {
  __typename?: 'Team';
  auctionPriority: Scalars['Int'];
  canViewIdentityEmails: Scalars['Boolean'];
  color?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  teamExperts?: Maybe<Array<genTeamOnExpertsForVendor>>;
  vendor?: Maybe<genVendor>;
};

export type genTeamOnExpertsForVendor = {
  __typename?: 'TeamOnExpertsForVendor';
  team?: Maybe<genTeam>;
  vendorExpert?: Maybe<genExpertForVendor>;
};

export type genTeamPriorityInput = {
  auctionPriority: Scalars['Int'];
  id: Scalars['ID'];
};

export enum TextAlignment {
  Center = 'CENTER',
  Left = 'LEFT',
  Right = 'RIGHT'
}

export type genTheme = {
  __typename?: 'Theme';
  accent: Scalars['String'];
  /** The date the object was created. */
  created: Scalars['DateTime'];
  darkest: Scalars['String'];
  id: Scalars['ID'];
  illustration: Scalars['String'];
  lightest: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
};

export type genUpdateProductInput = {
  productId: Scalars['ID'];
  publish?: InputMaybe<Scalars['Boolean']>;
};

export type genUpdateVendorBrandingInput = {
  logo?: InputMaybe<Scalars['Upload']>;
  name?: InputMaybe<Scalars['String']>;
};

export type genUpdateVendorSettingsInput = {
  faqLink?: InputMaybe<Scalars['String']>;
  hideWidget?: InputMaybe<Scalars['Boolean']>;
  inlineActivatorAnchorPosition?: InputMaybe<AnchorPosition | `${AnchorPosition}`>;
  inlineActivatorBackgroundColor?: InputMaybe<Scalars['String']>;
  inlineActivatorBorderRadiusInPX?: InputMaybe<Scalars['Int']>;
  inlineActivatorEnabled?: InputMaybe<Scalars['Boolean']>;
  inlineActivatorExternalHorizontalSpacingInPX?: InputMaybe<Scalars['Int']>;
  inlineActivatorExternalVerticalSpacingInPX?: InputMaybe<Scalars['Int']>;
  inlineActivatorFontSizeInPX?: InputMaybe<Scalars['Int']>;
  inlineActivatorInternalHorizontalPaddingInPX?: InputMaybe<Scalars['Int']>;
  inlineActivatorInternalVerticalPaddingInPX?: InputMaybe<Scalars['Int']>;
  inlineActivatorText?: InputMaybe<Scalars['String']>;
  inlineActivatorTextAlignment?: InputMaybe<TextAlignment | `${TextAlignment}`>;
  inlineActivatorTextColor?: InputMaybe<Scalars['String']>;
  inlineActivatorType?: InputMaybe<InlineActivatorType | `${InlineActivatorType}`>;
  inlineAnchorSelector?: InputMaybe<Scalars['String']>;
  shopUrl?: InputMaybe<Scalars['String']>;
  shouldHideWhenExpertsOffline?: InputMaybe<Scalars['Boolean']>;
  showActivator?: InputMaybe<DisplayType | `${DisplayType}`>;
  supportLink?: InputMaybe<Scalars['String']>;
  /** The amount of time (in seconds - min 30) after an idle close warning triggered by customer abandonment that we'll close the chat. */
  timeFromIdleWarningToCloseCustomerAbandonmentInSeconds?: InputMaybe<Scalars['Int']>;
  /** The amount of time (in seconds - min 30) after an idle close warning triggered by expert abandonment that we'll close the chat. */
  timeFromIdleWarningToCloseExpertAbandonmentInSeconds?: InputMaybe<Scalars['Int']>;
  /** The amount of time (in seconds - min 30) after a customer's abandons chat that we'll display an idle close warning. */
  timeToIdleWarningCustomerAbandonmentInSeconds?: InputMaybe<Scalars['Int']>;
  /** The amount of time (in seconds - min 30) after an expert's abandons chat that we'll display an idle close warning. */
  timeToIdleWarningExpertAbandonmentInSeconds?: InputMaybe<Scalars['Int']>;
  whitelistedRegions?: InputMaybe<Array<CountryCode | `${CountryCode}`>>;
};

export type genUser = {
  __typename?: 'User';
  /** The date the object was created. */
  created: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  expertProfile?: Maybe<genExpertProfile>;
  id: Scalars['ID'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  permissions: Array<GlobalPermission | `${GlobalPermission}`>;
  role: Role | `${Role}`;
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
  vendorMemberships: Array<genVendorMembership>;
};

export type genUserAgent = {
  __typename?: 'UserAgent';
  browser?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  deviceModel?: Maybe<Scalars['String']>;
  deviceType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  ipAddress: Scalars['String'];
  lastSeen: Scalars['DateTime'];
  location?: Maybe<Scalars['String']>;
  os?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};

export type genUserRating = {
  __typename?: 'UserRating';
  /** The date the object was created. */
  created: Scalars['DateTime'];
  id: Scalars['ID'];
  lead: Scalars['String'];
  rating: Scalars['Int'];
  recommendation?: Maybe<genRecommendation>;
  recommendationGroup?: Maybe<genRecommendationGroup>;
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
};

export type genUserRatingEdge = {
  __typename?: 'UserRatingEdge';
  cursor: Scalars['ID'];
  node: genUserRating;
};

export type genUserUpdateInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type genVariant = {
  __typename?: 'Variant';
  /** The date the object was created. */
  created: Scalars['DateTime'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  images: Array<genImage>;
  name: Scalars['String'];
  price?: Maybe<genPrice>;
  productId: Scalars['String'];
  /** The variant quantity in stock if we're pulling inventory from the vendor (may be < 0). Null if we're not. */
  quantity?: Maybe<Scalars['Int']>;
  sku?: Maybe<Scalars['String']>;
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
};


export type genVariantImagesArgs = {
  take?: InputMaybe<Scalars['Int']>;
};


export type genVariantPriceArgs = {
  currency: Currency;
};

export type genVendor = {
  __typename?: 'Vendor';
  /** @deprecated Used in old widget settings. Not used anymore. */
  activatorType: ActivatorType | `${ActivatorType}`;
  /** For conversion-related metrics, this is the number of days after an action       (like chatting with an expert) that a conversion can be attributed to that action. */
  attributionPeriod: Scalars['Int'];
  cannedResponses: Array<genCannedResponse>;
  categories: genPaginatedCategory;
  conversationAggregateStatistics: genVendorConversationAggregateStatistics;
  conversions: genPaginatedConversion;
  /** The date the object was created. */
  created: Scalars['DateTime'];
  eComIntegrations: Array<genEComIntegration>;
  expertAvatarLineup: Array<Scalars['String']>;
  experts: genPaginatedExpertForVendor;
  faqLink?: Maybe<Scalars['String']>;
  /** returns a "featured" expert, preferring one that is online for the vendor */
  featuredProfile?: Maybe<genFeaturedProfile>;
  hasExpertAvailable: Scalars['Boolean'];
  /** Whether the widget should be hidden on this vendor.       Takes precedence over `shouldHideWhenExpertsOffline`. */
  hideWidget: Scalars['Boolean'];
  id: Scalars['ID'];
  inlineActivatorSettings: genVendorInlineActivatorSettings;
  isImportingProducts: Scalars['Boolean'];
  labelOverrides: Array<genLabelOverride>;
  logo?: Maybe<Scalars['String']>;
  members: Array<genVendorMembership>;
  name: Scalars['String'];
  productTags: Array<genProductTag>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  quizzes: Array<genQuiz>;
  shopUrl: Scalars['String'];
  shouldAppear: Scalars['Boolean'];
  /** Whether the widget should be hidden on the vendor when no experts are online. */
  shouldHideWhenExpertsOffline: Scalars['Boolean'];
  showActivator: DisplayType | `${DisplayType}`;
  slug: Scalars['String'];
  supportLink?: Maybe<Scalars['String']>;
  teams: Array<genTeam>;
  theme?: Maybe<genTheme>;
  /** The customer inactivity time after their idle close warning after which we'll idle close chat. */
  timeFromIdleWarningToCloseCustomerAbandonmentInSeconds: Scalars['Int'];
  /** The expert inactivity time after their idle close warning after which we'll idle close chat. */
  timeFromIdleWarningToCloseExpertAbandonmentInSeconds: Scalars['Int'];
  /** The customer inactivity time after which we'll send an idle close warning to chat. */
  timeToIdleWarningCustomerAbandonmentInSeconds: Scalars['Int'];
  /** The expert inactivity time after which we'll send an idle close warning to chat. */
  timeToIdleWarningExpertAbandonmentInSeconds: Scalars['Int'];
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
  whitelistedRegions: Array<CountryCode | `${CountryCode}`>;
  zIndex: Scalars['String'];
};


export type genVendorCategoriesArgs = {
  cursor?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type genVendorConversationAggregateStatisticsArgs = {
  end?: InputMaybe<Scalars['DateTime']>;
  start?: InputMaybe<Scalars['DateTime']>;
};


export type genVendorConversionsArgs = {
  cursor?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<genConversionFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type genVendorExpertsArgs = {
  cursor?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<genExpertsForVendorFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<genExpertsForVendorSortInput>>;
};


export type genVendorLabelOverridesArgs = {
  language?: InputMaybe<Language>;
};


export type genVendorShouldAppearArgs = {
  lead?: InputMaybe<Scalars['String']>;
  path: Scalars['String'];
};

export type genVendorConversationAggregateStatistics = {
  __typename?: 'VendorConversationAggregateStatistics';
  /** The average order value (AoV) of customers that have chatted. */
  aovForChatters?: Maybe<Scalars['Float']>;
  /** The average order value (AoV) of customers that haven't chatted. */
  aovForNonChatters?: Maybe<Scalars['Float']>;
  /** The average time the expert takes to respond to a customer's message (in seconds).       Null if no experts on the brand have chatted with a customer yet. */
  averageExpertResponseTime?: Maybe<Scalars['Float']>;
  /** Percentage of chatting users that've converted. */
  conversionRateForChatters?: Maybe<Scalars['Float']>;
  /** Percentage of non-chatting users that've converted. */
  conversionRateForNonChatters?: Maybe<Scalars['Float']>;
  /** The CSAT (or customer satisfaction) score for all experts on a vendor. This is the percentage of npsSurveys       that were rated positively expressed as a number between 0 & 1. Null if no surveys have been completed on the vendor. */
  csatScore?: Maybe<Scalars['Float']>;
  /** The median time for experts to join (in seconds) on a conversation.       Null if no experts on the brand have chatted with a customer in the given period. */
  medianJoinTime?: Maybe<Scalars['Float']>;
  numberOfChats: Scalars['Int'];
  numberOfChattersWhoAbandonedCart: Scalars['Int'];
  numberOfChattersWhoConverted: Scalars['Int'];
  numberOfChattersWhoDidntAddToCart: Scalars['Int'];
  /** The number of unique experts that chatted on this vendor. */
  numberOfChattingExperts: Scalars['Int'];
  /** Number of conversions attributed to remark in some way. */
  numberOfConversionsAttributed: Scalars['Int'];
  /** Number of conversions not attributed to remark in any way. */
  numberOfConversionsNotAttributed: Scalars['Int'];
  numberOfNonChattersWhoAbandonedCart: Scalars['Int'];
  numberOfNonChattersWhoConverted: Scalars['Int'];
  numberOfNonChattersWhoDidntAddToCart: Scalars['Int'];
  /** The experts who have had the most conversations. */
  topExperts: Array<genExpertProfileChatCount>;
  /** This vendor's products most frequently recommended in chat. */
  topRecommendedProductsInChat: Array<genProductRecommendationCount>;
  /** The total # of all add to cart events performed by chatters (not just while chatting). */
  totalAddToCartsAttributedToChat: Scalars['Int'];
  /** The total # of add to cart events that happened during conversations on this brand. */
  totalAddToCartsDuringConversations: Scalars['Int'];
  /** The total number of hours experts spent in chats on this brand. */
  totalManHoursSpentInChat: Scalars['Float'];
  /** The sum of total prices on conversions attributed to chat. */
  totalValueOfConversionsAttributedToChat: Scalars['Float'];
  vendorId: Scalars['ID'];
};


export type genVendorConversationAggregateStatisticsTopExpertsArgs = {
  first: Scalars['Int'];
};


export type genVendorConversationAggregateStatisticsTopRecommendedProductsInChatArgs = {
  first: Scalars['Int'];
};

export type genVendorEdge = {
  __typename?: 'VendorEdge';
  cursor: Scalars['ID'];
  node: genVendor;
};

export type genVendorFilterInput = {
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type genVendorInlineActivatorSettings = {
  __typename?: 'VendorInlineActivatorSettings';
  inlineActivatorAnchorPosition: AnchorPosition | `${AnchorPosition}`;
  inlineActivatorBackgroundColor: Scalars['String'];
  inlineActivatorBorderRadiusInPX: Scalars['Int'];
  inlineActivatorEnabled: Scalars['Boolean'];
  inlineActivatorExternalHorizontalSpacingInPX: Scalars['Int'];
  inlineActivatorExternalVerticalSpacingInPX: Scalars['Int'];
  inlineActivatorFontSizeInPX: Scalars['Int'];
  inlineActivatorInternalHorizontalPaddingInPX: Scalars['Int'];
  inlineActivatorInternalVerticalPaddingInPX: Scalars['Int'];
  inlineActivatorText: Scalars['String'];
  inlineActivatorTextAlignment: TextAlignment | `${TextAlignment}`;
  inlineActivatorTextColor: Scalars['String'];
  inlineActivatorType: InlineActivatorType | `${InlineActivatorType}`;
  inlineAnchorSelector?: Maybe<Scalars['String']>;
};

export type genVendorMembership = {
  __typename?: 'VendorMembership';
  /** The date the object was created. */
  created: Scalars['DateTime'];
  createdBy?: Maybe<genUser>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  permissions: Array<VendorPermission | `${VendorPermission}`>;
  role: VendorMembershipRole | `${VendorMembershipRole}`;
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
  user: genUser;
  vendor: genVendor;
};

/** The role which the user possesses on this vendor */
export enum VendorMembershipRole {
  Admin = 'ADMIN',
  Owner = 'OWNER',
  Staff = 'STAFF'
}

/** Permissions which may appear on a Vendor Member */
export enum VendorPermission {
  EditBranding = 'EDIT_BRANDING',
  EditCannedResponses = 'EDIT_CANNED_RESPONSES',
  EditIntegrations = 'EDIT_INTEGRATIONS',
  EditProducts = 'EDIT_PRODUCTS',
  EditVendorExperts = 'EDIT_VENDOR_EXPERTS',
  EditVendorMembers = 'EDIT_VENDOR_MEMBERS',
  EditVendorTeams = 'EDIT_VENDOR_TEAMS',
  EditWidgetSettings = 'EDIT_WIDGET_SETTINGS',
  ViewConversations = 'VIEW_CONVERSATIONS',
  ViewNps = 'VIEW_NPS',
  ViewPii = 'VIEW_PII',
  ViewVendor = 'VIEW_VENDOR'
}

export type genVendorSegmentStatistics = {
  __typename?: 'VendorSegmentStatistics';
  aiAppliedTags: Array<genAiClassificationTag>;
  aiInferredSentiment?: Maybe<Scalars['String']>;
  aiProcessingStatus: AiProcessingStatus | `${AiProcessingStatus}`;
  conversationCloseDate: Scalars['DateTime'];
  /** The date the object was created. */
  created: Scalars['DateTime'];
  experts: Array<genExpertProfile>;
  id: Scalars['ID'];
  netPromoterScoreSurvey?: Maybe<genNetPromoterScoreSurvey>;
  /**
   * in seconds
   * Just the pairing portion of the totalTimeSpentChatting
   */
  pairingTime: Scalars['Float'];
  /**
   * in seconds
   * The total time the conversation was open/pending for, including pairing time
   */
  totalTimeSpentChatting: Scalars['Float'];
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
};

export type genVendorTermsOfService = {
  __typename?: 'VendorTermsOfService';
  content: Scalars['String'];
  cookiePolicyLink: Scalars['String'];
  /** The date the object was created. */
  created: Scalars['DateTime'];
  id: Scalars['ID'];
  privacyPolicyLink: Scalars['String'];
  termsOfServiceLink: Scalars['String'];
  /** The date the object was last updated. */
  updated: Scalars['DateTime'];
  versionNumber: Scalars['Int'];
};

export type genVendorUpdateInput = {
  /** For conversion-related metrics, this is the number of days after an action       (like chatting with an expert) that a conversion can be attributed to that action. */
  attributionPeriod?: InputMaybe<Scalars['Int']>;
  faqLink?: InputMaybe<Scalars['String']>;
  hideWidget?: InputMaybe<Scalars['Boolean']>;
  logo?: InputMaybe<Scalars['Upload']>;
  name?: InputMaybe<Scalars['String']>;
  publish?: InputMaybe<Scalars['Boolean']>;
  shopUrl?: InputMaybe<Scalars['String']>;
  shouldHideWhenExpertsOffline?: InputMaybe<Scalars['Boolean']>;
  showActivator?: InputMaybe<DisplayType | `${DisplayType}`>;
  slug?: InputMaybe<Scalars['String']>;
  supportLink?: InputMaybe<Scalars['String']>;
  /** The amount of time (in seconds - min 30) after an idle close warning triggered by customer abandonment that we'll close the chat. */
  timeFromIdleWarningToCloseCustomerAbandonmentInSeconds?: InputMaybe<Scalars['Int']>;
  /** The amount of time (in seconds - min 30) after an idle close warning triggered by expert abandonment that we'll close the chat. */
  timeFromIdleWarningToCloseExpertAbandonmentInSeconds?: InputMaybe<Scalars['Int']>;
  /** The amount of time (in seconds - min 30) after a customer's abandons chat that we'll display an idle close warning. */
  timeToIdleWarningCustomerAbandonmentInSeconds?: InputMaybe<Scalars['Int']>;
  /** The amount of time (in seconds - min 30) after an expert's abandons chat that we'll display an idle close warning. */
  timeToIdleWarningExpertAbandonmentInSeconds?: InputMaybe<Scalars['Int']>;
  whitelistedRegions?: InputMaybe<Array<CountryCode | `${CountryCode}`>>;
};

export type genWidgetInstallation = {
  __typename?: 'WidgetInstallation';
  installed: Scalars['Boolean'];
  installedAt?: Maybe<Scalars['DateTime']>;
};

export type genVendorFragmentFragment = { __typename?: 'Vendor', id: string, name: string, logo?: string | null, shouldAppear: boolean, zIndex: string, faqLink?: string | null, supportLink?: string | null, showActivator: DisplayType, expertAvatarLineup: Array<string>, featuredProfile?: { __typename?: 'FeaturedProfile', avatar?: string | null, publicName: string } | null, labelOverrides: Array<{ __typename?: 'LabelOverride', id: string, key: string, value: string }> };

export type genSessionFragmentFragment = { __typename?: 'Session', id: string, lead: string, isIdentified: boolean, isControlGroup: boolean, vendorLiftTestId?: string | null, openConversation?: { __typename?: 'Conversation', id: string, twilioSid: string } | null, vendor: { __typename?: 'Vendor', id: string, name: string, logo?: string | null, shouldAppear: boolean, zIndex: string, faqLink?: string | null, supportLink?: string | null, showActivator: DisplayType, expertAvatarLineup: Array<string>, featuredProfile?: { __typename?: 'FeaturedProfile', avatar?: string | null, publicName: string } | null, labelOverrides: Array<{ __typename?: 'LabelOverride', id: string, key: string, value: string }> } };

export type genImageFragmentFragment = { __typename?: 'Image', id: string, position?: number | null, url: string, srcset?: string | null };

export type genPriceFragmentFragment = { __typename?: 'Price', id: string, price: number, currency: Currency };

export type genRecommendationFragmentFragment = { __typename?: 'Recommendation', id: string, headline: string, body: string, product?: { __typename?: 'Product', id: string, name: string, brandName: string, publishedAt?: any | null, externalUrl?: string | null, price?: { __typename?: 'Price', id: string, price: number, currency: Currency } | null, images: Array<{ __typename?: 'Image', id: string, position?: number | null, url: string, srcset?: string | null }> } | null, variant?: { __typename?: 'Variant', id: string, name: string, sku?: string | null, images: Array<{ __typename?: 'Image', id: string, position?: number | null, url: string, srcset?: string | null }>, price?: { __typename?: 'Price', id: string, price: number, currency: Currency } | null } | null };

export type genConversationFragmentFragment = { __typename?: 'Conversation', id: string, status?: ConversationStatus | null, twilioSid: string, vendor: { __typename?: 'Vendor', id: string, slug: string }, participants: Array<{ __typename?: 'ConversationParticipant', chatServiceUsername: string, name: string, avatarUrl?: string | null, expertProfile?: { __typename?: 'ExpertProfile', id: string, publicName: string, avatar?: string | null, coverPhoto?: string | null, bio?: string | null, tagline?: string | null, link?: string | null, qualifications: Array<{ __typename?: 'Qualification', id: string, icon: string, title: string, endDate?: any | null, startDate: any }>, socialLinks: Array<{ __typename?: 'SocialMediaLink', link?: string | null, socialMediaNetworkName: SocialNetwork }>, expertFacts: Array<{ __typename?: 'FactOnExpert', id: string, icon: string, response: string }>, gallery: Array<{ __typename?: 'ExpertImage', id: string, url: string }> } | null }>, currentExpert?: { __typename?: 'ExpertProfile', id: string, publicName: string, avatar?: string | null, coverPhoto?: string | null, bio?: string | null, tagline?: string | null, link?: string | null, qualifications: Array<{ __typename?: 'Qualification', id: string, icon: string, title: string, endDate?: any | null, startDate: any }>, socialLinks: Array<{ __typename?: 'SocialMediaLink', link?: string | null, socialMediaNetworkName: SocialNetwork }>, expertFacts: Array<{ __typename?: 'FactOnExpert', id: string, icon: string, response: string }>, gallery: Array<{ __typename?: 'ExpertImage', id: string, url: string }> } | null, npsSurveys: Array<{ __typename?: 'NetPromoterScoreSurvey', rating?: number | null, tag?: NpsTag | null, id: string, additionalNotes?: string | null, created: any, updated: any, completed: boolean, skipped: boolean, expert: { __typename?: 'ExpertProfile', id: string, publicName: string, avatar?: string | null, coverPhoto?: string | null, bio?: string | null, tagline?: string | null, link?: string | null, qualifications: Array<{ __typename?: 'Qualification', id: string, icon: string, title: string, endDate?: any | null, startDate: any }>, socialLinks: Array<{ __typename?: 'SocialMediaLink', link?: string | null, socialMediaNetworkName: SocialNetwork }>, expertFacts: Array<{ __typename?: 'FactOnExpert', id: string, icon: string, response: string }>, gallery: Array<{ __typename?: 'ExpertImage', id: string, url: string }> } }> };

export type genParticipantFragmentFragment = { __typename?: 'ConversationParticipant', chatServiceUsername: string, name: string, avatarUrl?: string | null, expertProfile?: { __typename?: 'ExpertProfile', id: string, publicName: string, avatar?: string | null, coverPhoto?: string | null, bio?: string | null, tagline?: string | null, link?: string | null, qualifications: Array<{ __typename?: 'Qualification', id: string, icon: string, title: string, endDate?: any | null, startDate: any }>, socialLinks: Array<{ __typename?: 'SocialMediaLink', link?: string | null, socialMediaNetworkName: SocialNetwork }>, expertFacts: Array<{ __typename?: 'FactOnExpert', id: string, icon: string, response: string }>, gallery: Array<{ __typename?: 'ExpertImage', id: string, url: string }> } | null };

export type genExpertFragmentFragment = { __typename?: 'ExpertProfile', id: string, publicName: string, avatar?: string | null, coverPhoto?: string | null, bio?: string | null, tagline?: string | null, link?: string | null, qualifications: Array<{ __typename?: 'Qualification', id: string, icon: string, title: string, endDate?: any | null, startDate: any }>, socialLinks: Array<{ __typename?: 'SocialMediaLink', link?: string | null, socialMediaNetworkName: SocialNetwork }>, expertFacts: Array<{ __typename?: 'FactOnExpert', id: string, icon: string, response: string }>, gallery: Array<{ __typename?: 'ExpertImage', id: string, url: string }> };

export type genNpsFragmentFragment = { __typename?: 'NetPromoterScoreSurvey', rating?: number | null, tag?: NpsTag | null, id: string, additionalNotes?: string | null, created: any, updated: any, completed: boolean, skipped: boolean, expert: { __typename?: 'ExpertProfile', id: string, publicName: string, avatar?: string | null, coverPhoto?: string | null, bio?: string | null, tagline?: string | null, link?: string | null, qualifications: Array<{ __typename?: 'Qualification', id: string, icon: string, title: string, endDate?: any | null, startDate: any }>, socialLinks: Array<{ __typename?: 'SocialMediaLink', link?: string | null, socialMediaNetworkName: SocialNetwork }>, expertFacts: Array<{ __typename?: 'FactOnExpert', id: string, icon: string, response: string }>, gallery: Array<{ __typename?: 'ExpertImage', id: string, url: string }> } };

export type genStartConversationMutationVariables = Exact<{
  lead?: InputMaybe<Scalars['String']>;
  vendorId: Scalars['ID'];
}>;


export type genStartConversationMutation = { __typename?: 'Mutation', createConversation: { __typename?: 'Conversation', id: string, status?: ConversationStatus | null, twilioSid: string, vendor: { __typename?: 'Vendor', id: string, slug: string }, participants: Array<{ __typename?: 'ConversationParticipant', chatServiceUsername: string, name: string, avatarUrl?: string | null, expertProfile?: { __typename?: 'ExpertProfile', id: string, publicName: string, avatar?: string | null, coverPhoto?: string | null, bio?: string | null, tagline?: string | null, link?: string | null, qualifications: Array<{ __typename?: 'Qualification', id: string, icon: string, title: string, endDate?: any | null, startDate: any }>, socialLinks: Array<{ __typename?: 'SocialMediaLink', link?: string | null, socialMediaNetworkName: SocialNetwork }>, expertFacts: Array<{ __typename?: 'FactOnExpert', id: string, icon: string, response: string }>, gallery: Array<{ __typename?: 'ExpertImage', id: string, url: string }> } | null }>, currentExpert?: { __typename?: 'ExpertProfile', id: string, publicName: string, avatar?: string | null, coverPhoto?: string | null, bio?: string | null, tagline?: string | null, link?: string | null, qualifications: Array<{ __typename?: 'Qualification', id: string, icon: string, title: string, endDate?: any | null, startDate: any }>, socialLinks: Array<{ __typename?: 'SocialMediaLink', link?: string | null, socialMediaNetworkName: SocialNetwork }>, expertFacts: Array<{ __typename?: 'FactOnExpert', id: string, icon: string, response: string }>, gallery: Array<{ __typename?: 'ExpertImage', id: string, url: string }> } | null, npsSurveys: Array<{ __typename?: 'NetPromoterScoreSurvey', rating?: number | null, tag?: NpsTag | null, id: string, additionalNotes?: string | null, created: any, updated: any, completed: boolean, skipped: boolean, expert: { __typename?: 'ExpertProfile', id: string, publicName: string, avatar?: string | null, coverPhoto?: string | null, bio?: string | null, tagline?: string | null, link?: string | null, qualifications: Array<{ __typename?: 'Qualification', id: string, icon: string, title: string, endDate?: any | null, startDate: any }>, socialLinks: Array<{ __typename?: 'SocialMediaLink', link?: string | null, socialMediaNetworkName: SocialNetwork }>, expertFacts: Array<{ __typename?: 'FactOnExpert', id: string, icon: string, response: string }>, gallery: Array<{ __typename?: 'ExpertImage', id: string, url: string }> } }> } };

export type genSendEventMutationVariables = Exact<{
  input: genCreateCustomerEventInput;
}>;


export type genSendEventMutation = { __typename?: 'Mutation', sendEvent: boolean };

export type genIdentifyMutationVariables = Exact<{
  lead: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  conversationId?: InputMaybe<Scalars['ID']>;
  requestId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
}>;


export type genIdentifyMutation = { __typename?: 'Mutation', identifyLead?: string | null };

export type genPostOrderMutationVariables = Exact<{
  shopUrl: Scalars['String'];
  lead?: InputMaybe<Scalars['String']>;
  rawData: Scalars['String'];
  platform: Platform;
}>;


export type genPostOrderMutation = { __typename?: 'Mutation', postOrder?: boolean | null };

export type genSurveyResponseMutationVariables = Exact<{
  lead: Scalars['String'];
  id: Scalars['ID'];
  notes?: InputMaybe<Scalars['String']>;
  rating: Scalars['Int'];
  tag?: InputMaybe<NpsTag>;
}>;


export type genSurveyResponseMutation = { __typename?: 'Mutation', submitNPS: { __typename?: 'NetPromoterScoreSurvey', rating?: number | null, tag?: NpsTag | null, id: string, additionalNotes?: string | null, created: any, updated: any, completed: boolean, skipped: boolean, expert: { __typename?: 'ExpertProfile', id: string, publicName: string, avatar?: string | null, coverPhoto?: string | null, bio?: string | null, tagline?: string | null, link?: string | null, qualifications: Array<{ __typename?: 'Qualification', id: string, icon: string, title: string, endDate?: any | null, startDate: any }>, socialLinks: Array<{ __typename?: 'SocialMediaLink', link?: string | null, socialMediaNetworkName: SocialNetwork }>, expertFacts: Array<{ __typename?: 'FactOnExpert', id: string, icon: string, response: string }>, gallery: Array<{ __typename?: 'ExpertImage', id: string, url: string }> } } };

export type genSkipSurveyResponseMutationVariables = Exact<{
  lead: Scalars['String'];
  id: Scalars['ID'];
}>;


export type genSkipSurveyResponseMutation = { __typename?: 'Mutation', skipNPS: { __typename?: 'NetPromoterScoreSurvey', rating?: number | null, tag?: NpsTag | null, id: string, additionalNotes?: string | null, created: any, updated: any, completed: boolean, skipped: boolean, expert: { __typename?: 'ExpertProfile', id: string, publicName: string, avatar?: string | null, coverPhoto?: string | null, bio?: string | null, tagline?: string | null, link?: string | null, qualifications: Array<{ __typename?: 'Qualification', id: string, icon: string, title: string, endDate?: any | null, startDate: any }>, socialLinks: Array<{ __typename?: 'SocialMediaLink', link?: string | null, socialMediaNetworkName: SocialNetwork }>, expertFacts: Array<{ __typename?: 'FactOnExpert', id: string, icon: string, response: string }>, gallery: Array<{ __typename?: 'ExpertImage', id: string, url: string }> } } };

export type genReopenConversationMutationVariables = Exact<{
  conversationId: Scalars['ID'];
  lead: Scalars['String'];
}>;


export type genReopenConversationMutation = { __typename?: 'Mutation', reopenConversation?: { __typename?: 'Conversation', id: string, status?: ConversationStatus | null, twilioSid: string, vendor: { __typename?: 'Vendor', id: string, slug: string }, participants: Array<{ __typename?: 'ConversationParticipant', chatServiceUsername: string, name: string, avatarUrl?: string | null, expertProfile?: { __typename?: 'ExpertProfile', id: string, publicName: string, avatar?: string | null, coverPhoto?: string | null, bio?: string | null, tagline?: string | null, link?: string | null, qualifications: Array<{ __typename?: 'Qualification', id: string, icon: string, title: string, endDate?: any | null, startDate: any }>, socialLinks: Array<{ __typename?: 'SocialMediaLink', link?: string | null, socialMediaNetworkName: SocialNetwork }>, expertFacts: Array<{ __typename?: 'FactOnExpert', id: string, icon: string, response: string }>, gallery: Array<{ __typename?: 'ExpertImage', id: string, url: string }> } | null }>, currentExpert?: { __typename?: 'ExpertProfile', id: string, publicName: string, avatar?: string | null, coverPhoto?: string | null, bio?: string | null, tagline?: string | null, link?: string | null, qualifications: Array<{ __typename?: 'Qualification', id: string, icon: string, title: string, endDate?: any | null, startDate: any }>, socialLinks: Array<{ __typename?: 'SocialMediaLink', link?: string | null, socialMediaNetworkName: SocialNetwork }>, expertFacts: Array<{ __typename?: 'FactOnExpert', id: string, icon: string, response: string }>, gallery: Array<{ __typename?: 'ExpertImage', id: string, url: string }> } | null, npsSurveys: Array<{ __typename?: 'NetPromoterScoreSurvey', rating?: number | null, tag?: NpsTag | null, id: string, additionalNotes?: string | null, created: any, updated: any, completed: boolean, skipped: boolean, expert: { __typename?: 'ExpertProfile', id: string, publicName: string, avatar?: string | null, coverPhoto?: string | null, bio?: string | null, tagline?: string | null, link?: string | null, qualifications: Array<{ __typename?: 'Qualification', id: string, icon: string, title: string, endDate?: any | null, startDate: any }>, socialLinks: Array<{ __typename?: 'SocialMediaLink', link?: string | null, socialMediaNetworkName: SocialNetwork }>, expertFacts: Array<{ __typename?: 'FactOnExpert', id: string, icon: string, response: string }>, gallery: Array<{ __typename?: 'ExpertImage', id: string, url: string }> } }> } | null };

export type genCancelIdleCloseMutationVariables = Exact<{
  conversationId: Scalars['ID'];
  lead?: InputMaybe<Scalars['String']>;
}>;


export type genCancelIdleCloseMutation = { __typename?: 'Mutation', cancelIdleClose: { __typename?: 'Conversation', id: string } };

export type genGetRecommendationQueryVariables = Exact<{
  id: Scalars['ID'];
  currency: Currency;
}>;


export type genGetRecommendationQuery = { __typename?: 'Query', recommendation?: { __typename?: 'Recommendation', id: string, headline: string, body: string, product?: { __typename?: 'Product', id: string, name: string, brandName: string, publishedAt?: any | null, externalUrl?: string | null, price?: { __typename?: 'Price', id: string, price: number, currency: Currency } | null, images: Array<{ __typename?: 'Image', id: string, position?: number | null, url: string, srcset?: string | null }> } | null, variant?: { __typename?: 'Variant', id: string, name: string, sku?: string | null, images: Array<{ __typename?: 'Image', id: string, position?: number | null, url: string, srcset?: string | null }>, price?: { __typename?: 'Price', id: string, price: number, currency: Currency } | null } | null } | null };

export type genGetSessionQueryVariables = Exact<{
  shopUrl: Scalars['String'];
  lead?: InputMaybe<Scalars['String']>;
  path: Scalars['String'];
}>;


export type genGetSessionQuery = { __typename?: 'Query', session?: { __typename?: 'Session', id: string, lead: string, isIdentified: boolean, isControlGroup: boolean, vendorLiftTestId?: string | null, openConversation?: { __typename?: 'Conversation', id: string, twilioSid: string } | null, vendor: { __typename?: 'Vendor', id: string, name: string, logo?: string | null, shouldAppear: boolean, zIndex: string, faqLink?: string | null, supportLink?: string | null, showActivator: DisplayType, expertAvatarLineup: Array<string>, featuredProfile?: { __typename?: 'FeaturedProfile', avatar?: string | null, publicName: string } | null, labelOverrides: Array<{ __typename?: 'LabelOverride', id: string, key: string, value: string }> } } | null };

export type genGetExpertQueryVariables = Exact<{
  expertId: Scalars['ID'];
}>;


export type genGetExpertQuery = { __typename?: 'Query', expertProfile?: { __typename?: 'ExpertProfile', id: string, publicName: string, avatar?: string | null, coverPhoto?: string | null, bio?: string | null, tagline?: string | null, link?: string | null, qualifications: Array<{ __typename?: 'Qualification', id: string, icon: string, title: string, endDate?: any | null, startDate: any }>, socialLinks: Array<{ __typename?: 'SocialMediaLink', link?: string | null, socialMediaNetworkName: SocialNetwork }>, expertFacts: Array<{ __typename?: 'FactOnExpert', id: string, icon: string, response: string }>, gallery: Array<{ __typename?: 'ExpertImage', id: string, url: string }> } | null };

export type genGetConversationQueryVariables = Exact<{
  lead?: InputMaybe<Scalars['String']>;
  conversationId?: InputMaybe<Scalars['ID']>;
}>;


export type genGetConversationQuery = { __typename?: 'Query', conversation?: { __typename?: 'Conversation', id: string, status?: ConversationStatus | null, twilioSid: string, vendor: { __typename?: 'Vendor', id: string, slug: string }, participants: Array<{ __typename?: 'ConversationParticipant', chatServiceUsername: string, name: string, avatarUrl?: string | null, expertProfile?: { __typename?: 'ExpertProfile', id: string, publicName: string, avatar?: string | null, coverPhoto?: string | null, bio?: string | null, tagline?: string | null, link?: string | null, qualifications: Array<{ __typename?: 'Qualification', id: string, icon: string, title: string, endDate?: any | null, startDate: any }>, socialLinks: Array<{ __typename?: 'SocialMediaLink', link?: string | null, socialMediaNetworkName: SocialNetwork }>, expertFacts: Array<{ __typename?: 'FactOnExpert', id: string, icon: string, response: string }>, gallery: Array<{ __typename?: 'ExpertImage', id: string, url: string }> } | null }>, currentExpert?: { __typename?: 'ExpertProfile', id: string, publicName: string, avatar?: string | null, coverPhoto?: string | null, bio?: string | null, tagline?: string | null, link?: string | null, qualifications: Array<{ __typename?: 'Qualification', id: string, icon: string, title: string, endDate?: any | null, startDate: any }>, socialLinks: Array<{ __typename?: 'SocialMediaLink', link?: string | null, socialMediaNetworkName: SocialNetwork }>, expertFacts: Array<{ __typename?: 'FactOnExpert', id: string, icon: string, response: string }>, gallery: Array<{ __typename?: 'ExpertImage', id: string, url: string }> } | null, npsSurveys: Array<{ __typename?: 'NetPromoterScoreSurvey', rating?: number | null, tag?: NpsTag | null, id: string, additionalNotes?: string | null, created: any, updated: any, completed: boolean, skipped: boolean, expert: { __typename?: 'ExpertProfile', id: string, publicName: string, avatar?: string | null, coverPhoto?: string | null, bio?: string | null, tagline?: string | null, link?: string | null, qualifications: Array<{ __typename?: 'Qualification', id: string, icon: string, title: string, endDate?: any | null, startDate: any }>, socialLinks: Array<{ __typename?: 'SocialMediaLink', link?: string | null, socialMediaNetworkName: SocialNetwork }>, expertFacts: Array<{ __typename?: 'FactOnExpert', id: string, icon: string, response: string }>, gallery: Array<{ __typename?: 'ExpertImage', id: string, url: string }> } }> } | null };

export type genGetConversationStatusQueryVariables = Exact<{
  lead?: InputMaybe<Scalars['String']>;
  conversationId?: InputMaybe<Scalars['ID']>;
}>;


export type genGetConversationStatusQuery = { __typename?: 'Query', conversation?: { __typename?: 'Conversation', id: string, status?: ConversationStatus | null } | null };

export type genRefreshCurrentExpertQueryVariables = Exact<{
  conversationId: Scalars['ID'];
  lead?: InputMaybe<Scalars['String']>;
}>;


export type genRefreshCurrentExpertQuery = { __typename?: 'Query', conversation?: { __typename?: 'Conversation', id: string, currentExpert?: { __typename?: 'ExpertProfile', id: string, publicName: string, avatar?: string | null, coverPhoto?: string | null, bio?: string | null, tagline?: string | null, link?: string | null, qualifications: Array<{ __typename?: 'Qualification', id: string, icon: string, title: string, endDate?: any | null, startDate: any }>, socialLinks: Array<{ __typename?: 'SocialMediaLink', link?: string | null, socialMediaNetworkName: SocialNetwork }>, expertFacts: Array<{ __typename?: 'FactOnExpert', id: string, icon: string, response: string }>, gallery: Array<{ __typename?: 'ExpertImage', id: string, url: string }> } | null, participants: Array<{ __typename?: 'ConversationParticipant', chatServiceUsername: string, name: string, avatarUrl?: string | null, expertProfile?: { __typename?: 'ExpertProfile', id: string, publicName: string, avatar?: string | null, coverPhoto?: string | null, bio?: string | null, tagline?: string | null, link?: string | null, qualifications: Array<{ __typename?: 'Qualification', id: string, icon: string, title: string, endDate?: any | null, startDate: any }>, socialLinks: Array<{ __typename?: 'SocialMediaLink', link?: string | null, socialMediaNetworkName: SocialNetwork }>, expertFacts: Array<{ __typename?: 'FactOnExpert', id: string, icon: string, response: string }>, gallery: Array<{ __typename?: 'ExpertImage', id: string, url: string }> } | null }> } | null };

export type genRefreshConversationStatusQueryVariables = Exact<{
  conversationId: Scalars['ID'];
  lead?: InputMaybe<Scalars['String']>;
}>;


export type genRefreshConversationStatusQuery = { __typename?: 'Query', conversation?: { __typename?: 'Conversation', id: string, status?: ConversationStatus | null } | null };

export type genRefreshConversationParticipantsQueryVariables = Exact<{
  conversationId: Scalars['ID'];
  lead?: InputMaybe<Scalars['String']>;
}>;


export type genRefreshConversationParticipantsQuery = { __typename?: 'Query', conversation?: { __typename?: 'Conversation', id: string, participants: Array<{ __typename?: 'ConversationParticipant', chatServiceUsername: string, name: string, avatarUrl?: string | null, expertProfile?: { __typename?: 'ExpertProfile', id: string, publicName: string, avatar?: string | null, coverPhoto?: string | null, bio?: string | null, tagline?: string | null, link?: string | null, qualifications: Array<{ __typename?: 'Qualification', id: string, icon: string, title: string, endDate?: any | null, startDate: any }>, socialLinks: Array<{ __typename?: 'SocialMediaLink', link?: string | null, socialMediaNetworkName: SocialNetwork }>, expertFacts: Array<{ __typename?: 'FactOnExpert', id: string, icon: string, response: string }>, gallery: Array<{ __typename?: 'ExpertImage', id: string, url: string }> } | null }> } | null };

export type genFindSurveyQueryVariables = Exact<{
  id: Scalars['ID'];
  lead?: InputMaybe<Scalars['String']>;
}>;


export type genFindSurveyQuery = { __typename?: 'Query', npsSurveyById?: { __typename?: 'NetPromoterScoreSurvey', rating?: number | null, tag?: NpsTag | null, id: string, additionalNotes?: string | null, created: any, updated: any, completed: boolean, skipped: boolean, expert: { __typename?: 'ExpertProfile', id: string, publicName: string, avatar?: string | null, coverPhoto?: string | null, bio?: string | null, tagline?: string | null, link?: string | null, qualifications: Array<{ __typename?: 'Qualification', id: string, icon: string, title: string, endDate?: any | null, startDate: any }>, socialLinks: Array<{ __typename?: 'SocialMediaLink', link?: string | null, socialMediaNetworkName: SocialNetwork }>, expertFacts: Array<{ __typename?: 'FactOnExpert', id: string, icon: string, response: string }>, gallery: Array<{ __typename?: 'ExpertImage', id: string, url: string }> } } | null };

export type genGetCurrentExpertQueryVariables = Exact<{
  id: Scalars['ID'];
  lead?: InputMaybe<Scalars['String']>;
}>;


export type genGetCurrentExpertQuery = { __typename?: 'Query', conversation?: { __typename?: 'Conversation', id: string, currentExpert?: { __typename?: 'ExpertProfile', id: string, publicName: string, avatar?: string | null, coverPhoto?: string | null, bio?: string | null, tagline?: string | null, link?: string | null, qualifications: Array<{ __typename?: 'Qualification', id: string, icon: string, title: string, endDate?: any | null, startDate: any }>, socialLinks: Array<{ __typename?: 'SocialMediaLink', link?: string | null, socialMediaNetworkName: SocialNetwork }>, expertFacts: Array<{ __typename?: 'FactOnExpert', id: string, icon: string, response: string }>, gallery: Array<{ __typename?: 'ExpertImage', id: string, url: string }> } | null } | null };

export type genGetCurrentParticipantQueryVariables = Exact<{
  id: Scalars['ID'];
  lead?: InputMaybe<Scalars['String']>;
}>;


export type genGetCurrentParticipantQuery = { __typename?: 'Query', conversation?: { __typename?: 'Conversation', id: string, participants: Array<{ __typename?: 'ConversationParticipant', chatServiceUsername: string, name: string, avatarUrl?: string | null, expertProfile?: { __typename?: 'ExpertProfile', id: string, publicName: string, avatar?: string | null, coverPhoto?: string | null, bio?: string | null, tagline?: string | null, link?: string | null, qualifications: Array<{ __typename?: 'Qualification', id: string, icon: string, title: string, endDate?: any | null, startDate: any }>, socialLinks: Array<{ __typename?: 'SocialMediaLink', link?: string | null, socialMediaNetworkName: SocialNetwork }>, expertFacts: Array<{ __typename?: 'FactOnExpert', id: string, icon: string, response: string }>, gallery: Array<{ __typename?: 'ExpertImage', id: string, url: string }> } | null }> } | null };

export type genGetChatTokenQueryVariables = Exact<{
  lead?: InputMaybe<Scalars['String']>;
}>;


export type genGetChatTokenQuery = { __typename?: 'Query', chatServiceAccessToken?: string | null };

export const VendorFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"vendorFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Vendor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"shouldAppear"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}},{"kind":"Argument","name":{"kind":"Name","value":"lead"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead"}}}]},{"kind":"Field","name":{"kind":"Name","value":"zIndex"}},{"kind":"Field","name":{"kind":"Name","value":"faqLink"}},{"kind":"Field","name":{"kind":"Name","value":"supportLink"}},{"kind":"Field","name":{"kind":"Name","value":"showActivator"}},{"kind":"Field","name":{"kind":"Name","value":"expertAvatarLineup"}},{"kind":"Field","name":{"kind":"Name","value":"featuredProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"publicName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"labelOverrides"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"EnumValue","value":"EN"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<genVendorFragmentFragment, unknown>;
export const SessionFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"sessionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Session"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead"}},{"kind":"Field","name":{"kind":"Name","value":"isIdentified"}},{"kind":"Field","name":{"kind":"Name","value":"isControlGroup"}},{"kind":"Field","name":{"kind":"Name","value":"vendorLiftTestId"}},{"kind":"Field","name":{"kind":"Name","value":"openConversation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"twilioSid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"vendorFragment"}}]}}]}}]} as unknown as DocumentNode<genSessionFragmentFragment, unknown>;
export const PriceFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"priceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Price"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]} as unknown as DocumentNode<genPriceFragmentFragment, unknown>;
export const ImageFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"imageFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Image"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"srcset"}}]}}]} as unknown as DocumentNode<genImageFragmentFragment, unknown>;
export const RecommendationFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"recommendationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Recommendation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"brandName"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"currency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"priceFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"3"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"3"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"currency"},"value":{"kind":"EnumValue","value":"USD"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"priceFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"body"}}]}}]} as unknown as DocumentNode<genRecommendationFragmentFragment, unknown>;
export const ExpertFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"expertFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExpertProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publicName"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"coverPhoto"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"tagline"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"qualifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"socialLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"socialMediaNetworkName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expertFacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"response"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gallery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<genExpertFragmentFragment, unknown>;
export const ParticipantFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"participantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConversationParticipant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatServiceUsername"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"expertProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"expertFragment"}}]}}]}}]} as unknown as DocumentNode<genParticipantFragmentFragment, unknown>;
export const NpsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"npsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NetPromoterScoreSurvey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"additionalNotes"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"skipped"}},{"kind":"Field","name":{"kind":"Name","value":"expert"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"expertFragment"}}]}}]}}]} as unknown as DocumentNode<genNpsFragmentFragment, unknown>;
export const ConversationFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"conversationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Conversation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includePastParticipants"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"participantFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"twilioSid"}},{"kind":"Field","name":{"kind":"Name","value":"currentExpert"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"expertFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"npsSurveys"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lead"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"npsFragment"}}]}}]}}]} as unknown as DocumentNode<genConversationFragmentFragment, unknown>;
export const StartConversationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartConversation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vendorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createConversation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lead"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead"}}},{"kind":"Argument","name":{"kind":"Name","value":"vendorId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"vendorId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"conversationFragment"}}]}}]}},...ConversationFragmentFragmentDoc.definitions,...ParticipantFragmentFragmentDoc.definitions,...ExpertFragmentFragmentDoc.definitions,...NpsFragmentFragmentDoc.definitions]} as unknown as DocumentNode<genStartConversationMutation, genStartConversationMutationVariables>;
export const SendEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCustomerEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sendEventInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<genSendEventMutation, genSendEventMutationVariables>;
export const IdentifyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Identify"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requestId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identifyLead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lead"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"Argument","name":{"kind":"Name","value":"conversationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"requestMessageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requestId"}}},{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}}]}]}}]} as unknown as DocumentNode<genIdentifyMutation, genIdentifyMutationVariables>;
export const PostOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"postOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shopUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rawData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Platform"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"shopUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shopUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"lead"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead"}}},{"kind":"Argument","name":{"kind":"Name","value":"rawData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rawData"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}}]}]}}]} as unknown as DocumentNode<genPostOrderMutation, genPostOrderMutationVariables>;
export const SurveyResponseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SurveyResponse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notes"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rating"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tag"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NPSTag"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitNPS"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lead"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead"}}},{"kind":"Argument","name":{"kind":"Name","value":"npsSurveyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"tag"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tag"}}},{"kind":"Argument","name":{"kind":"Name","value":"rating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rating"}}},{"kind":"Argument","name":{"kind":"Name","value":"additionalNotes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"npsFragment"}}]}}]}},...NpsFragmentFragmentDoc.definitions,...ExpertFragmentFragmentDoc.definitions]} as unknown as DocumentNode<genSurveyResponseMutation, genSurveyResponseMutationVariables>;
export const SkipSurveyResponseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SkipSurveyResponse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"skipNPS"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lead"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead"}}},{"kind":"Argument","name":{"kind":"Name","value":"npsSurveyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"npsFragment"}}]}}]}},...NpsFragmentFragmentDoc.definitions,...ExpertFragmentFragmentDoc.definitions]} as unknown as DocumentNode<genSkipSurveyResponseMutation, genSkipSurveyResponseMutationVariables>;
export const ReopenConversationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReopenConversation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reopenConversation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"conversationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lead"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"conversationFragment"}}]}}]}},...ConversationFragmentFragmentDoc.definitions,...ParticipantFragmentFragmentDoc.definitions,...ExpertFragmentFragmentDoc.definitions,...NpsFragmentFragmentDoc.definitions]} as unknown as DocumentNode<genReopenConversationMutation, genReopenConversationMutationVariables>;
export const CancelIdleCloseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelIdleClose"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelIdleClose"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"conversationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lead"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<genCancelIdleCloseMutation, genCancelIdleCloseMutationVariables>;
export const GetRecommendationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRecommendation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Currency"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recommendation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"recommendationFragment"}}]}}]}},...RecommendationFragmentFragmentDoc.definitions,...PriceFragmentFragmentDoc.definitions,...ImageFragmentFragmentDoc.definitions]} as unknown as DocumentNode<genGetRecommendationQuery, genGetRecommendationQueryVariables>;
export const GetSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shopUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"session"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"shopUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shopUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"lead"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"sessionFragment"}}]}}]}},...SessionFragmentFragmentDoc.definitions,...VendorFragmentFragmentDoc.definitions]} as unknown as DocumentNode<genGetSessionQuery, genGetSessionQueryVariables>;
export const GetExpertDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetExpert"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expertId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expertProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expertId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"expertFragment"}}]}}]}},...ExpertFragmentFragmentDoc.definitions]} as unknown as DocumentNode<genGetExpertQuery, genGetExpertQueryVariables>;
export const GetConversationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetConversation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lead"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"conversationFragment"}}]}}]}},...ConversationFragmentFragmentDoc.definitions,...ParticipantFragmentFragmentDoc.definitions,...ExpertFragmentFragmentDoc.definitions,...NpsFragmentFragmentDoc.definitions]} as unknown as DocumentNode<genGetConversationQuery, genGetConversationQueryVariables>;
export const GetConversationStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetConversationStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lead"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<genGetConversationStatusQuery, genGetConversationStatusQueryVariables>;
export const RefreshCurrentExpertDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RefreshCurrentExpert"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lead"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currentExpert"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"expertFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includePastParticipants"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"participantFragment"}}]}}]}}]}},...ExpertFragmentFragmentDoc.definitions,...ParticipantFragmentFragmentDoc.definitions]} as unknown as DocumentNode<genRefreshCurrentExpertQuery, genRefreshCurrentExpertQueryVariables>;
export const RefreshConversationStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RefreshConversationStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lead"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<genRefreshConversationStatusQuery, genRefreshConversationStatusQueryVariables>;
export const RefreshConversationParticipantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RefreshConversationParticipants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lead"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includePastParticipants"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"participantFragment"}}]}}]}}]}},...ParticipantFragmentFragmentDoc.definitions,...ExpertFragmentFragmentDoc.definitions]} as unknown as DocumentNode<genRefreshConversationParticipantsQuery, genRefreshConversationParticipantsQueryVariables>;
export const FindSurveyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindSurvey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"npsSurveyById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"surveyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"lead"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"npsFragment"}}]}}]}},...NpsFragmentFragmentDoc.definitions,...ExpertFragmentFragmentDoc.definitions]} as unknown as DocumentNode<genFindSurveyQuery, genFindSurveyQueryVariables>;
export const GetCurrentExpertDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentExpert"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"lead"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currentExpert"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"expertFragment"}}]}}]}}]}},...ExpertFragmentFragmentDoc.definitions]} as unknown as DocumentNode<genGetCurrentExpertQuery, genGetCurrentExpertQueryVariables>;
export const GetCurrentParticipantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentParticipant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"lead"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"participantFragment"}}]}}]}}]}},...ParticipantFragmentFragmentDoc.definitions,...ExpertFragmentFragmentDoc.definitions]} as unknown as DocumentNode<genGetCurrentParticipantQuery, genGetCurrentParticipantQueryVariables>;
export const GetChatTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetChatToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatServiceAccessToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lead"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead"}}}]}]}}]} as unknown as DocumentNode<genGetChatTokenQuery, genGetChatTokenQueryVariables>;